import { Component, AfterContentChecked, OnInit, Input, Compiler, NgModule } from '@angular/core';
import { NgForm,FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConsigmentUploadService } from 'app/cs/service/consignment-upload.service';
import { GridOptions } from "ag-grid";
declare var $: any;
declare const require: any;
import {DropDownEditor} from "app/cs/views/drop-down-editor/drop.down.editor";
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import {ButtonRendererComponent} from "app/cs/views/app-button/app-button.component";

interface City {
  name: string;
  value: string;
}

interface Status {
  name: string;
  value: string;
}

@Component({
  selector: 'client-home',
  templateUrl: './client-home.component.html',
  styleUrls: ['./client-home.component.css']
})

export class ClientHomeComponent implements OnInit {
  userId: String;
  carrierVal: string;
  statusVal: string;
  fromDate: String;
  toDate: String;
  errorMsg: string;
  CSstatus: String;
  private gridOptions: GridOptions;
  successMsg: String;
  pageSwitch: String; 
  moveValidFlag:Boolean;
  bulkUpload: Boolean;
  moveValidViewFlag: Boolean;
  statusUpdateFlag: Boolean;
  commentsUpdateFlag: Boolean;
  handlingUpdateFlag: Boolean;
  customerServiceForm: FormGroup;
  handlingVal: String;
  csSystemSelectedVal: csSystemSelectedVal;
  reference_number_val: String;
  reference_number_array: String;
  barcode_label_val: String;
  articleID_val: String;
  airwayBill_val: String;
  broker_Name_val: String;
  carrier_val: String;
  status_val: String;
  suburb_val: String;
  receiverName_val: String;
  receiverAddress_val: String;
  phoneNumber_val: String;
  state_val: String;
  postcode_val: String;
  comments_val: String;
  dateAllocated_val: String;
  status_Timestamp_val: String;
  systemStatus_val: String;
  updated_Timestamp_val: String;
  actionVal: String;
  userMessage: userMessage;

  private gridOptionsMaster: GridOptions;
  private gridOptionsReceived: GridOptions;
  private gridOptionsLIT: GridOptions;
  private gridOptionsTransit: GridOptions;
  private gridOptionsProactive: GridOptions;
  private gridOptionsInquiry: GridOptions;
  private gridOptionsDelivered: GridOptions;
  private gridOptionsReturns: GridOptions;
  private gridOptionsReturned: GridOptions;
  private gridOptionsResent: GridOptions;
  private gridOptionsMsg: GridOptions;

  private autoGroupColumnDef;
  private rowGroupPanelShow;
  private defaultColDef;
  private rowData: any[];
  cities2: City[];  
  status: Status[];
  handling: Status[];
  handlingDropdown: Status[];
  actionDropdown: Status[];
  selectedStatus: Status;
  selectedHandling: Status;
  selectedAction : Status;
  public customerTrackerList = [];
  private customerTrackerMessageList = [];
  private customerAllocatedList = [];
  private customerIntransistList = [];
  private customerProactiveList = [];
  private customerInquiryList = [];
  private customerReceivedList = [];
  private customeDeliveredList = [];
  private customeReturnsList = [];
  private customeReturnedList = [];
  private customeResentList = [];
  private bulkUpdateList = [];
  private rowDataMaster: any[];
  private rowDataReceived: any[]
  private rowDataAllocated: any[];
  private rowDataTransit: any[];
  private rowDataProactive: any[];
  private rowDataInquiry: any[];
  private rowDataDelivered: any[];
  private rowDataReturns: any[];
  private rowDataReturned: any[];
  private rowDataResent: any[];
  private rowDataMsg: any[];
  trackingPrintForm: FormGroup;

  frameworkComponents = {
    buttonRenderer: ButtonRendererComponent,
  }

  constructor(
    public consigmentUploadService: ConsigmentUploadService,
    private spinner: NgxSpinnerService,
    private _compiler: Compiler
  ){
    this.trackingPrintForm = new FormGroup({
      refNum: new FormControl(),
      fromDate: new FormControl(),
      toDate: new FormControl()
    });
    this._compiler.clearCache();
    this.moveValidFlag = true;
    this.bulkUpload = false;
    this.statusUpdateFlag = false;
    this.commentsUpdateFlag = false;
    this.handlingUpdateFlag = false;
    this.moveValidViewFlag = true;
    this.actionVal = '';
    this.handlingVal = '';
    this.cities2 = [];
    this.customerTrackerList = [];
    this.cities2 = [
      {"name":"BEN","value":"BEN"},
      {"name":"CAL","value":"CAL"},
      {"name":"GPC","value":"GPC"},
      {"name":"YVT","value":"YVT"},
      {"name":"MLD","value":"MLD"},
      {"name":"SWH","value":"SWH"}
    ];

  this.customerServiceForm = new FormGroup({
    reference_number: new FormControl({disabled: true}, Validators.required),
    barcodelabelNumber: new FormControl({disabled: true}),
    articleID: new FormControl({disabled: true}, Validators.required),
    dateAllocated: new FormControl({disabled: true}, Validators.required),
    broker_Name: new FormControl({disabled: true}, Validators.required),
    carrier: new FormControl({disabled: true}, Validators.required),
    receiverName: new FormControl({disabled: true}),
    receiverAddress: new FormControl({disabled: true}),
    phoneNumber: new FormControl({disabled: true}),
    suburb: new FormControl({disabled: true}),
    state: new FormControl({disabled: true}),
    postcode: new FormControl({disabled: true}),
    user: new FormControl({disabled: true})
  });

  this.status = [];
  this.status = [
      {"name":"","value":""},
      {"name":"DATA RECEIVED BY D2Z","value":"DATA RECEIVED"},
      {"name":"ALLOCATED BY D2Z","value":"ALLOCATED"},
      {"name":"RECEIVED BY DEPOT","value":"RECEIVED"},
      {"name":"DELIVERED","value":"DELIVERED"},
      {"name":"RTS","value":"RTS"}
  ];
  
   // Master Screen
   this.gridOptionsMaster = <GridOptions>{ rowSelection: "multiple" };
   this.gridOptionsMaster.columnDefs = [
      {
        headerName: "Broker Name",
        field: "broker_Name",
        width: 130,
        checkboxSelection: true,
        headerCheckboxSelection: function(params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        }
      },
      {
        headerName: "Article ID",
        field: "articleID",
        width: 170
      },
      {
        headerName: "Reference Number",
        field: "reference_number",
        width: 200
      },   
      {
        headerName: "Date Allocated",
        field: "dateAllocated",
        width: 150
      },
      {
        headerName: "Carrier",
        field: "carrier",
        width: 80
      },
      {
        headerName: "view",
        width: 80,
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          onClick: this.assign.bind(this),
          label: "View"
        }
      },
      {
        headerName: "Actual Status",
        field: "status",
        width: 150
      },
      {
        headerName: "Actual Status Timestamp",
        field: "status_Timestamp",
        width: 150
      },
      {
        headerName: "Mapped Status",
        field: "mappedStatus",
        width: 140
      },
      {
        headerName: "Mapped Status Timestamp",
        field: "status_Timestamp",
        width: 150
      },
     // {
       // headerName: "ETA",
        //field: "eta",
        //width: 150
      //},
      {
      headerName: "Action",
      field: "action",
      width: 160,
      cellEditorFramework: DropDownEditor,
      editable:true,
      cellEditorParams : {
          options: [
           /* {
              name: "Data Received Tab",
              value: "Data received by D2Z"
            },
            {
              name: "Allocated Tab",
              value: "Allocated by D2Z" 
            },*/
            {
              name: "In Transit Tab",
              value: "In Transit"
            },
            /*{
              name: "Pro Active Tab",
              value: "ProActive CS"
            },*/
            {
              name: "Inquiry Tab",
              value: "Inquiry"
            },
            {
              name: "Delivered Tab",
              value: "Delivered"
            },
          /*  {
              name: "Returning Tab",
              value: "Returning"
            },*/
            {
              name: "Returned Tab",
              value: "Returned"
            },
            {
              name: "Resent Tab",
              value: "Resent"
            }
          ]
      }
    },
    {
      headerName: "Handling",
      field: "handling",
      width: 160,
      cellEditorFramework: DropDownEditor,
      editable:true,
      cellEditorParams : {
          options: [
            {
              name: "David",
              value: "David"
            },
            {
              name: "Nirmal",
              value: "Nirmal"
            },
            {
              name: "Bala",
              value: "Bala"
            },
            {
              name: "Mary-Ann",
              value: "Mary-Ann"
            },
            {
              name: "Chris",
              value: "Chris"
            },
             {
              name: "Rajkamal",
              value: "Rajkamal"
            },
              {
              name: "Hope",
              value: "Hope"
            }
          ]
      }
    },
    {
      headerName: "Receiver Name",
      field: "receiverName",
      width: 150,
      hide: true,
      suppressToolPanel: true
    },
    {
      headerName: "Receiver Address",
      field: "receiverAddress",
      width: 150,
      hide: true,
      suppressToolPanel: true
    },
    {
      headerName: "Phone Number",
      field: "phoneNumber",
      width: 150,
      hide: true,
      suppressToolPanel: true
    },
    {
      headerName: "Suburb",
      field: "suburb",
      width: 150,
      hide: true,
      suppressToolPanel: true
    },
    {
      headerName: "State",
      field: "state",
      width: 150,
      hide: true,
      suppressToolPanel: true
    },
    {
      headerName: "Postcode",
      field: "postcode",
      width: 150,
      hide: true,
      suppressToolPanel: true
    }
   ];

   //  Consignment Received Screen
   this.gridOptionsReceived = <GridOptions>{ rowSelection: "multiple" };
   this.gridOptionsReceived.columnDefs = [
          {
            headerName: "Broker Name",
            field: "broker_Name",
            width: 130,
            checkboxSelection: true,
            headerCheckboxSelection: function(params) {
              return params.columnApi.getRowGroupColumns().length === 0;
            }
          },
          {
            headerName: "Article ID",
            field: "articleID",
            width: 170
          },
          {
            headerName: "Reference Number",
            field: "reference_number",
            width: 200
          },   
           {
            headerName: "Date Allocated",
            field: "dateAllocated",
            width: 150
          },
          {
            headerName: "Carrier",
            field: "carrier",
            width: 80
          },
          {
            headerName: "view",
            width: 80,
            cellRenderer: "buttonRenderer",
            cellRendererParams: {
              onClick: this.assign.bind(this),
              label: "View"
            }
          },
           {
            headerName: "Actual Status",
            field: "status",
            width: 150
          },
          {
            headerName: "Actual Status Timestamp",
            field: "status_Timestamp",
            width: 150
          },
          {
            headerName: "Mapped Status",
            field: "mappedStatus",
            width: 140
          },
          {
            headerName: "Mapped Status Timestamp",
            field: "status_Timestamp",
            width: 150
          },
        /*  {
            headerName: "ETA",
            field: "eta",
            width: 150
          },*/
          {
            headerName: "Action",
            field: "action",
            width: 160,
            cellEditorFramework: DropDownEditor,
            editable:true,
            cellEditorParams : {
               options: [
                  /*  {
                      name: "Allocated Tab",
                      value: "Allocated by D2Z"
                    },*/
                    {
                      name: "In Transit Tab",
                      value: "In Transit"
                    },
               /*     {
                      name: "Pro Active Tab",
                      value: "ProActive CS"
                    },*/
                    {
                      name: "Inquiry Tab",
                      value: "Inquiry"
                    },
                    {
                      name: "Delivered Tab",
                      value: "Delivered"
                    },
                   /* {
                      name: "Returning Tab",
                      value: "Returning"
                    },*/
                    {
                      name: "Returned Tab",
                      value: "Returned"
                    },
                    {
                      name: "Resent Tab",
                      value: "Resent"
                    }
              ]
            }
          },
          {
            headerName: "Handling",
            field: "handling",
            width: 160,
            cellEditorFramework: DropDownEditor,
            editable:true,
            cellEditorParams : {
                options: [
                  {
                    name: "David",
                    value: "David"
                  },
                  {
                    name: "Nirmal",
                    value: "Nirmal"
                  },
                  {
                    name: "Bala",
                    value: "Bala"
                  },
                  {
                    name: "Mary-Ann",
                    value: "Mary-Ann"
                  },
                  {
                    name: "Chris",
                    value: "Chris"
                  },
                   {
              name: "Rajkamal",
              value: "Rajkamal"
            },
              {
              name: "Hope",
              value: "Hope"
            }
                ]
            }
          },
          {
            headerName: "Receiver Name",
            field: "receiverName",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "Receiver Address",
            field: "receiverAddress",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "Phone Number",
            field: "phoneNumber",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "Suburb",
            field: "suburb",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "State",
            field: "state",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "Postcode",
            field: "postcode",
            width: 150,
            hide: true,
            suppressToolPanel: true
          }
   ];

   //  Consignment Allocated Screen
   this.gridOptionsLIT = <GridOptions>{ rowSelection: "multiple" };
   this.gridOptionsLIT.columnDefs = [
        {
          headerName: "Broker Name",
          field: "broker_Name",
          width: 130,
          checkboxSelection: true,
          headerCheckboxSelection: function(params) {
            return params.columnApi.getRowGroupColumns().length === 0;
          }
        },
        {
          headerName: "Article ID",
          field: "articleID",
          width: 170
        },
        {
          headerName: "Reference Number",
          field: "reference_number",
          width: 200
        },   
        {
          headerName: "Date Allocated",
          field: "dateAllocated",
          width: 150
        },
        {
          headerName: "Carrier",
          field: "carrier",
          width: 80
        },
        {
          headerName: "view",
          width: 80,
          cellRenderer: "buttonRenderer",
          cellRendererParams: {
            onClick: this.assign.bind(this),
            label: "View"
          }
        },
         {
            headerName: "Actual Status",
            field: "status",
            width: 150
          },
          {
            headerName: "Actual Status Timestamp",
            field: "status_Timestamp",
            width: 150
          },
          {
            headerName: "Mapped Status",
            field: "mappedStatus",
            width: 140
          },
          {
            headerName: "Mapped Status Timestamp",
            field: "status_Timestamp",
            width: 150
          },
         /* {
            headerName: "ETA",
            field: "eta",
            width: 150
          },*/
        {
          headerName: "Action",
          field: "action",
          width: 160,
          cellEditorFramework: DropDownEditor,
          editable:true,
          cellEditorParams : {
              options: [
             /*   {
                    name: "Data Received Tab",
                    value: "Data received by D2Z"
                  },*/
                  {
                    name: "In Transit Tab",
                    value: "In Transit"
                  },
                 /* {
                    name: "Pro Active Tab",
                    value: "ProActive CS"
                  },*/
                  {
                    name: "Inquiry Tab",
                    value: "Inquiry"
                  },
                  {
                    name: "Delivered Tab",
                    value: "Delivered"
                  },
                /*  {
                    name: "Returning Tab",
                    value: "Returning"
                  },*/
                  {
                    name: "Returned Tab",
                    value: "Returned"
                  },
                  {
                    name: "Resent Tab",
                    value: "Resent"
                  }
              ]
            }
        },
        {
          headerName: "Handling",
          field: "handling",
          width: 160,
          cellEditorFramework: DropDownEditor,
          editable:true,
          cellEditorParams : {
              options: [
                {
                  name: "David",
                  value: "David"
                },
                {
                  name: "Nirmal",
                  value: "Nirmal"
                },
                {
                  name: "Bala",
                  value: "Bala"
                },
                {
                  name: "Mary-Ann",
                  value: "Mary-Ann"
                },
                {
                  name: "Chris",
                  value: "Chris"
                },
                 {
              name: "Rajkamal",
              value: "Rajkamal"
            },  {
              name: "Hope",
              value: "Hope"
            }
            
              ]
          }
        },
        {
          headerName: "Receiver Name",
          field: "receiverName",
          width: 150,
          hide: true,
          suppressToolPanel: true
        },
        {
          headerName: "Receiver Address",
          field: "receiverAddress",
          width: 150,
          hide: true,
          suppressToolPanel: true
        },
        {
          headerName: "Phone Number",
          field: "phoneNumber",
          width: 150,
          hide: true,
          suppressToolPanel: true
        },
        {
          headerName: "Suburb",
          field: "suburb",
          width: 150,
          hide: true,
          suppressToolPanel: true
        },
        {
          headerName: "State",
          field: "state",
          width: 150,
          hide: true,
          suppressToolPanel: true
        },
        {
          headerName: "Postcode",
          field: "postcode",
          width: 150,
          hide: true,
          suppressToolPanel: true
        }
   ];

      //  Consignment Transit Screen
      this.gridOptionsTransit = <GridOptions>{ rowSelection: "multiple" };
      this.gridOptionsTransit.columnDefs = [
            {
              headerName: "Broker Name",
              field: "broker_Name",
              width: 130,
              checkboxSelection: true,
              headerCheckboxSelection: function(params) {
                return params.columnApi.getRowGroupColumns().length === 0;
              }
            },
            {
              headerName: "Article ID",
              field: "articleID",
              width: 170
            },
            {
              headerName: "Reference Number",
              field: "reference_number",
              width: 200
            },   
            {
              headerName: "Date Allocated",
              field: "dateAllocated",
              width: 150
            },
            {
              headerName: "Carrier",
              field: "carrier",
              width: 80
            },
            {
              headerName: "view",
              width: 80,
              cellRenderer: "buttonRenderer",
              cellRendererParams: {
                onClick: this.assign.bind(this),
                label: "View"
              }
            },
             {
              headerName: "Actual Status",
              field: "status",
              width: 150
            },
            {
              headerName: "Actual Status Timestamp",
              field: "status_Timestamp",
              width: 150
            },
            {
              headerName: "Mapped Status",
              field: "mappedStatus",
              width: 140
            },
            {
              headerName: "Mapped Status Timestamp",
              field: "status_Timestamp",
              width: 150
            },
         /*   {
              headerName: "ETA",
              field: "eta",
              width: 150
            },*/
            {
              headerName: "Action",
              field: "action",
              width: 160,
              cellEditorFramework: DropDownEditor,
              editable:true,
              cellEditorParams : {
                  options: [
                     /* {
                        name: "Data Received Tab",
                        value: "Data received by D2Z"
                      },
                      {
                        name: "Allocated Tab",
                        value: "Allocated by D2Z"
                      },
                      {
                        name: "Pro Active Tab",
                        value: "ProActive CS"
                      },*/
                      {
                        name: "Inquiry Tab",
                        value: "Inquiry"
                      },
                      {
                        name: "Delivered Tab",
                        value: "Delivered"
                      },
                     /* {
                        name: "Returning Tab",
                        value: "Returning"
                      },*/
                      {
                        name: "Returned Tab",
                        value: "Returned"
                      },
                      {
                        name: "Resent Tab",
                        value: "Resent"
                      }
                  ]
                }
            },
            {
              headerName: "Handling",
              field: "handling",
              width: 160,
              cellEditorFramework: DropDownEditor,
              editable:true,
              cellEditorParams : {
                  options: [
                    {
                      name: "David",
                      value: "David"
                    },
                    {
                      name: "Nirmal",
                      value: "Nirmal"
                    },
                    {
                      name: "Bala",
                      value: "Bala"
                    },
                    {
                      name: "Mary-Ann",
                      value: "Mary-Ann"
                    },
                    {
                      name: "Chris",
                      value: "Chris"
                    },
                     {
              name: "Rajkamal",
              value: "Rajkamal"
            },
             {
              name: "Hope",
              value: "Hope"
            }
                  ]
              }
            },
            {
              headerName: "Receiver Name",
              field: "receiverName",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Receiver Address",
              field: "receiverAddress",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Phone Number",
              field: "phoneNumber",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Suburb",
              field: "suburb",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "State",
              field: "state",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Postcode",
              field: "postcode",
              width: 150,
              hide: true,
              suppressToolPanel: true
            }
      ];

      //  Consignment PROACTIVE Screen
      this.gridOptionsProactive = <GridOptions>{ rowSelection: "multiple" };
      this.gridOptionsProactive.columnDefs = [
            {
              headerName: "Broker Name",
              field: "broker_Name",
              width: 130,
              checkboxSelection: true,
              headerCheckboxSelection: function(params) {
                return params.columnApi.getRowGroupColumns().length === 0;
              }
            },
            {
              headerName: "Article ID",
              field: "articleID",
              width: 170
            },
            {
              headerName: "Reference Number",
              field: "reference_number",
              width: 200
            },   
            {
              headerName: "Date Allocated",
              field: "dateAllocated",
              width: 150
            },
            {
              headerName: "Carrier",
              field: "carrier",
              width: 80
            },
            {
              headerName: "view",
              width: 80,
              cellRenderer: "buttonRenderer",
              cellRendererParams: {
                onClick: this.assign.bind(this),
                label: "View"
              }
            },
             {
              headerName: "Actual Status",
              field: "status",
              width: 150
            },
            {
              headerName: "Actual Status Timestamp",
              field: "status_Timestamp",
              width: 150
            },
            {
              headerName: "Mapped Status",
              field: "mappedStatus",
              width: 140
            },
            {
              headerName: "Mapped Status Timestamp",
              field: "status_Timestamp",
              width: 150
            },
           /* {
              headerName: "ETA",
              field: "eta",
              width: 150
            },*/
            {
              headerName: "Action",
              field: "action",
              width: 160,
              cellEditorFramework: DropDownEditor,
              editable:true,
              cellEditorParams : {
                  options: [
                    /*  {
                        name: "Data Received Tab",
                        value: "Data received by D2Z"
                      },
                      {
                        name: "Allocated Tab",
                        value: "Allocated by D2Z"
                      },*/
                      {
                        name: "In Transit Tab",
                        value: "In Transit"
                      },
                      {
                        name: "Inquiry Tab",
                        value: "Inquiry"
                      },
                      {
                        name: "Delivered Tab",
                        value: "Delivered"
                      },
                   /*   {
                        name: "Returning Tab",
                        value: "Returning"
                      },*/
                      {
                        name: "Returned Tab",
                        value: "Returned"
                      },
                      {
                        name: "Resent Tab",
                        value: "Resent"
                      }
                ]
              }
            },
            {
              headerName: "Handling",
              field: "handling",
              width: 160,
              cellEditorFramework: DropDownEditor,
              editable:true,
              cellEditorParams : {
                  options: [
                    {
                      name: "David",
                      value: "David"
                    },
                    {
                      name: "Nirmal",
                      value: "Nirmal"
                    },
                    {
                      name: "Bala",
                      value: "Bala"
                    },
                    {
                      name: "Mary-Ann",
                      value: "Mary-Ann"
                    },
                    {
                      name: "Chris",
                      value: "Chris"
                    },
                     {
              name: "Rajkamal",
              value: "Rajkamal"
            },
             {
              name: "Hope",
              value: "Hope"
            }
                  ]
              }
            },
            {
              headerName: "Receiver Name",
              field: "receiverName",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Receiver Address",
              field: "receiverAddress",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Phone Number",
              field: "phoneNumber",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Suburb",
              field: "suburb",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "State",
              field: "state",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Postcode",
              field: "postcode",
              width: 150,
              hide: true,
              suppressToolPanel: true
            }
      ];

      //  Consignment Inquiry Screen
      this.gridOptionsInquiry = <GridOptions>{ rowSelection: "multiple" };
      this.gridOptionsInquiry.columnDefs = [
            {
              headerName: "Broker Name",
              field: "broker_Name",
              width: 130,
              checkboxSelection: true,
              headerCheckboxSelection: function(params) {
                return params.columnApi.getRowGroupColumns().length === 0;
              }
            },
            {
              headerName: "Article ID",
              field: "articleID",
              width: 170
            },
            {
              headerName: "Reference Number",
              field: "reference_number",
              width: 200
            },   
            {
              headerName: "Date Allocated",
              field: "dateAllocated",
              width: 150
            },
            {
              headerName: "Carrier",
              field: "carrier",
              width: 80
            },
            {
              headerName: "view",
              width: 80,
              cellRenderer: "buttonRenderer",
              cellRendererParams: {
                onClick: this.assign.bind(this),
                label: "View"
              }
            },
             {
              headerName: "Actual Status",
              field: "status",
              width: 150
            },
            {
              headerName: "Actual Status Timestamp",
              field: "status_Timestamp",
              width: 150
            },
            {
              headerName: "Mapped Status",
              field: "mappedStatus",
              width: 140
            },
            {
              headerName: "Mapped Status Timestamp",
              field: "status_Timestamp",
              width: 150
            },
           /* {
              headerName: "ETA",
              field: "eta",
              width: 150
            },*/
            {
              headerName: "Action",
              field: "action",
              width: 160,
              cellEditorFramework: DropDownEditor,
              editable:true,
              cellEditorParams : {
                  options: [
                     /* {
                        name: "Data Received Tab",
                        value: "Data received by D2Z"
                      },
                      {
                        name: "Allocated Tab",
                        value: "Allocated by D2Z"
                      },*/
                      {
                        name: "In Transit Tab",
                        value: "In Transit"
                      },
                     /* {
                        name: "Pro Active Tab",
                        value: "ProActive CS"
                      },*/
                      {
                        name: "Delivered Tab",
                        value: "Delivered"
                      },
                  /*    {
                        name: "Returning Tab",
                        value: "Returning"
                      },*/
                      {
                        name: "Returned Tab",
                        value: "Returned"
                      },
                      {
                        name: "Resent Tab",
                        value: "Resent"
                      }
                    ]
              }
            },
            {
              headerName: "Handling",
              field: "handling",
              width: 160,
              cellEditorFramework: DropDownEditor,
              editable:true,
              cellEditorParams : {
                  options: [
                    {
                      name: "David",
                      value: "David"
                    },
                    {
                      name: "Nirmal",
                      value: "Nirmal"
                    },
                    {
                      name: "Bala",
                      value: "Bala"
                    },
                    {
                      name: "Mary-Ann",
                      value: "Mary-Ann"
                    },
                    {
                      name: "Chris",
                      value: "Chris"
                    },
                     {
              name: "Rajkamal",
              value: "Rajkamal"
            },
             {
              name: "Hope",
              value: "Hope"
            }
                  ]
              }
            },
            {
              headerName: "Receiver Name",
              field: "receiverName",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Receiver Address",
              field: "receiverAddress",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Phone Number",
              field: "phoneNumber",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Suburb",
              field: "suburb",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "State",
              field: "state",
              width: 150,
              hide: true,
              suppressToolPanel: true
            },
            {
              headerName: "Postcode",
              field: "postcode",
              width: 150,
              hide: true,
              suppressToolPanel: true
            }
      ];

       //  Consignment Delivered Screen
       this.gridOptionsDelivered = <GridOptions>{ rowSelection: "multiple" };
       this.gridOptionsDelivered.columnDefs = [
            {
              headerName: "Broker Name",
              field: "broker_Name",
              width: 130,
              checkboxSelection: true,
              headerCheckboxSelection: function(params) {
                return params.columnApi.getRowGroupColumns().length === 0;
              }
            },
            {
              headerName: "Article ID",
              field: "articleID",
              width: 170
            },
            {
              headerName: "Reference Number",
              field: "reference_number",
              width: 200
            },   
            {
              headerName: "Date Allocated",
              field: "dateAllocated",
              width: 150
            },
            {
              headerName: "Carrier",
              field: "carrier",
              width: 80
            },
            {
              headerName: "view",
              width: 80,
              cellRenderer: "buttonRenderer",
              cellRendererParams: {
                onClick: this.assign.bind(this),
                label: "View"
              }
            },
             {
              headerName: "Actual Status",
              field: "status",
              width: 150
            },
            {
              headerName: "Actual Status Timestamp",
              field: "status_Timestamp",
              width: 150
            },
            {
              headerName: "Mapped Status",
              field: "mappedStatus",
              width: 140
            },
            {
              headerName: "Mapped Status Timestamp",
              field: "status_Timestamp",
              width: 150
            },
         /*   {
              headerName: "ETA",
              field: "eta",
              width: 150
            },*/
            {
            headerName: "Action",
            field: "action",
            width: 160,
            cellEditorFramework: DropDownEditor,
            editable:true,
            cellEditorParams : {
                options: [
                  /*  {
                      name: "Data Received Tab",
                      value: "Data received by D2Z"
                    },
                    {
                      name: "Allocated Tab",
                      value: "Allocated by D2Z"
                    },*/
                    {
                      name: "In Transit Tab",
                      value: "In Transit"
                    },
                /*    {
                      name: "Pro Active Tab",
                      value: "ProActive CS"
                    },*/
                    {
                      name: "Inquiry Tab",
                      value: "Inquiry"
                    },
                /*    {
                      name: "Returning Tab",
                      value: "Returning"
                    },*/
                    {
                      name: "Returned Tab",
                      value: "Returned"
                    },
                    {
                      name: "Resent Tab",
                      value: "Resent"
                    }
                  ]
            }
          },
          {
            headerName: "Handling",
            field: "handling",
            width: 160,
            cellEditorFramework: DropDownEditor,
            editable:true,
            cellEditorParams : {
                options: [
                  {
                    name: "David",
                    value: "David"
                  },
                  {
                    name: "Nirmal",
                    value: "Nirmal"
                  },
                  {
                    name: "Bala",
                    value: "Bala"
                  },
                  {
                    name: "Mary-Ann",
                    value: "Mary-Ann"
                  },
                  {
                    name: "Chris",
                    value: "Chris"
                  },
                   {
              name: "Rajkamal",
              value: "Rajkamal"
            },
             {
              name: "Hope",
              value: "Hope"
            }
                ]
            }
          },
          {
            headerName: "Receiver Name",
            field: "receiverName",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "Receiver Address",
            field: "receiverAddress",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "Phone Number",
            field: "phoneNumber",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "Suburb",
            field: "suburb",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "State",
            field: "state",
            width: 150,
            hide: true,
            suppressToolPanel: true
          },
          {
            headerName: "Postcode",
            field: "postcode",
            width: 150,
            hide: true,
            suppressToolPanel: true
          }
       ];
 
      //  Consignment Retuens Screen
      this.gridOptionsReturns = <GridOptions>{ rowSelection: "multiple" };
        this.rowDataReturns = []
        this.gridOptionsReturns.columnDefs = [
                {
                  headerName: "Broker Name",
                  field: "broker_Name",
                  width: 130,
                  checkboxSelection: true,
                  headerCheckboxSelection: function(params) {
                    return params.columnApi.getRowGroupColumns().length === 0;
                  }
                },
                {
                  headerName: "Article ID",
                  field: "articleID",
                  width: 170
                },
                {
                  headerName: "Reference Number",
                  field: "reference_number",
                  width: 200
                },   
                {
                  headerName: "Date Allocated",
                  field: "dateAllocated",
                  width: 150
                },
                {
                  headerName: "Carrier",
                  field: "carrier",
                  width: 80
                },
                {
                  headerName: "view",
                  width: 80,
                  cellRenderer: "buttonRenderer",
                  cellRendererParams: {
                    onClick: this.assign.bind(this),
                    label: "View"
                  }
                },
                {
                  headerName: "Actual Status",
                  field: "status",
                  width: 150
                },
                {
                  headerName: "Actual Status Timestamp",
                  field: "status_Timestamp",
                  width: 150
                },
                {
                  headerName: "Mapped Status",
                  field: "mappedStatus",
                  width: 140
                },
                {
                  headerName: "Mapped Status Timestamp",
                  field: "status_Timestamp",
                  width: 150
                },
              /*  {
                  headerName: "ETA",
                  field: "eta",
                  width: 150
                },*/
                {
                  headerName: "Action",
                  field: "action",
                  width: 160,
                  cellEditorFramework: DropDownEditor,
                  editable:true,
                  cellEditorParams : {
                      options: [
                       /*   {
                            name: "Data Received Tab",
                            value: "Data received by D2Z"
                          },
                          {
                            name: "Allocated Tab",
                            value: "Allocated by D2Z"
                          },*/
                          {
                            name: "In Transit Tab",
                            value: "In Transit"
                          },
                       /*   {
                            name: "Pro Active Tab",
                            value: "ProActive CS"
                          },*/
                          {
                            name: "Inquiry Tab",
                            value: "Inquiry"
                          },
                          {
                            name: "Delivered Tab",
                            value: "Delivered"
                          },
                       /*   {
                            name: "Returned Tab",
                            value: "Returned"
                          },*/
                          {
                            name: "Resent Tab",
                            value: "Resent"
                          }
                        ]
                  }
                },
                {
                  headerName: "Handling",
                  field: "handling",
                  width: 160,
                  cellEditorFramework: DropDownEditor,
                  editable:true,
                  cellEditorParams : {
                      options: [
                        {
                          name: "David",
                          value: "David"
                        },
                        {
                          name: "Nirmal",
                          value: "Nirmal"
                        },
                        {
                          name: "Bala",
                          value: "Bala"
                        },
                        {
                          name: "Mary-Ann",
                          value: "Mary-Ann"
                        },
                        {
                          name: "Chris",
                          value: "Chris"
                        },
                         {
              name: "Rajkamal",
              value: "Rajkamal"
            },
             {
              name: "Hope",
              value: "Hope"
            }
                      ]
                  }
                },
                {
                  headerName: "Receiver Name",
                  field: "receiverName",
                  width: 150,
                  hide: true,
                  suppressToolPanel: true
                },
                {
                  headerName: "Receiver Address",
                  field: "receiverAddress",
                  width: 150,
                  hide: true,
                  suppressToolPanel: true
                },
                {
                  headerName: "Phone Number",
                  field: "phoneNumber",
                  width: 150,
                  hide: true,
                  suppressToolPanel: true
                },
                {
                  headerName: "Suburb",
                  field: "suburb",
                  width: 150,
                  hide: true,
                  suppressToolPanel: true
                },
                {
                  headerName: "State",
                  field: "state",
                  width: 150,
                  hide: true,
                  suppressToolPanel: true
                },
                {
                  headerName: "Postcode",
                  field: "postcode",
                  width: 150,
                  hide: true,
                  suppressToolPanel: true
                }
              ]; 

      //  Consignment Returned Screen
      this.gridOptionsReturned = <GridOptions>{ rowSelection: "multiple" };
      this.rowDataReturned = []
      this.gridOptionsReturned.columnDefs = [
              {
                headerName: "Broker Name",
                field: "broker_Name",
                width: 130,
                checkboxSelection: true,
                headerCheckboxSelection: function(params) {
                  return params.columnApi.getRowGroupColumns().length === 0;
                }
              },
              {
                headerName: "Article ID",
                field: "articleID",
                width: 170
              },
              {
                headerName: "Reference Number",
                field: "reference_number",
                width: 200
              },   
              {
                headerName: "Date Allocated",
                field: "dateAllocated",
                width: 150
              },
              {
                headerName: "Carrier",
                field: "carrier",
                width: 80
              },
              {
                headerName: "view",
                width: 80,
                cellRenderer: "buttonRenderer",
                cellRendererParams: {
                  onClick: this.assign.bind(this),
                  label: "View"
                }
              },
              {
                headerName: "Actual Status",
                field: "status",
                width: 150
              },
              {
                headerName: "Actual Status Timestamp",
                field: "status_Timestamp",
                width: 150
              },
              {
                headerName: "Mapped Status",
                field: "mappedStatus",
                width: 140
              },
              {
                headerName: "Mapped Status Timestamp",
                field: "status_Timestamp",
                width: 150
              },
          /*    {
                headerName: "ETA",
                field: "eta",
                width: 150
              },*/
              {
                headerName: "Action",
                field: "action",
                width: 160,
                cellEditorFramework: DropDownEditor,
                editable:true,
                cellEditorParams : {
                    options: [
                      /*  {
                          name: "Data Received Tab",
                          value: "Data received by D2Z"
                        },
                        {
                          name: "Allocated Tab",
                          value: "Allocated by D2Z"
                        },*/
                        {
                          name: "In Transit Tab",
                          value: "In Transit"
                        },
                 /*       {
                          name: "Pro Active Tab",
                          value: "ProActive CS"
                        },*/
                        {
                          name: "Inquiry Tab",
                          value: "Inquiry"
                        },
                        {
                          name: "Delivered Tab",
                          value: "Delivered"
                        },
                /*        {
                          name: "Returning Tab",
                          value: "Returning"
                        },*/
                        {
                          name: "Resent Tab",
                          value: "Resent"
                        }
                      ]
                }
              },
              {
                headerName: "Handling",
                field: "handling",
                width: 160,
                cellEditorFramework: DropDownEditor,
                editable:true,
                cellEditorParams : {
                    options: [
                      {
                        name: "David",
                        value: "David"
                      },
                      {
                        name: "Nirmal",
                        value: "Nirmal"
                      },
                      {
                        name: "Bala",
                        value: "Bala"
                      },
                      {
                        name: "Mary-Ann",
                        value: "Mary-Ann"
                      },
                      {
                        name: "Chris",
                        value: "Chris"
                      },
                       {
              name: "Rajkamal",
              value: "Rajkamal"
            },
             {
              name: "Hope",
              value: "Hope"
            }
                    ]
                }
              },
              {
                headerName: "Receiver Name",
                field: "receiverName",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Receiver Address",
                field: "receiverAddress",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Phone Number",
                field: "phoneNumber",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Suburb",
                field: "suburb",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "State",
                field: "state",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Postcode",
                field: "postcode",
                width: 150,
                hide: true,
                suppressToolPanel: true
              }
            ]; 

      //  Consignment Resent Screen
      this.gridOptionsResent = <GridOptions>{ rowSelection: "multiple" };
      this.rowDataResent = []
      this.gridOptionsResent.columnDefs = [
              {
                headerName: "Broker Name",
                field: "broker_Name",
                width: 130,
                checkboxSelection: true,
                headerCheckboxSelection: function(params) {
                  return params.columnApi.getRowGroupColumns().length === 0;
                }
              },
              {
                headerName: "Article ID",
                field: "articleID",
                width: 170
              },
              {
                headerName: "Reference Number",
                field: "reference_number",
                width: 200
              },   
              {
                headerName: "Date Allocated",
                field: "dateAllocated",
                width: 150
              },
              {
                headerName: "Carrier",
                field: "carrier",
                width: 80
              },
              {
                headerName: "view",
                width: 80,
                cellRenderer: "buttonRenderer",
                cellRendererParams: {
                  onClick: this.assign.bind(this),
                  label: "View"
                }
              },
              {
                headerName: "Actual Status",
                field: "status",
                width: 150
              },
              {
                headerName: "Actual Status Timestamp",
                field: "status_Timestamp",
                width: 150
              },
              {
                headerName: "Mapped Status",
                field: "mappedStatus",
                width: 140
              },
              {
                headerName: "Mapped Status Timestamp",
                field: "status_Timestamp",
                width: 150
              },
             /* {
                headerName: "ETA",
                field: "eta",
                width: 150
              },*/
              {
                headerName: "Action",
                field: "action",
                width: 160,
                cellEditorFramework: DropDownEditor,
                editable:true,
                cellEditorParams : {
                    options: [
                  /*      {
                          name: "Data Received Tab",
                          value: "Data received by D2Z"
                        },
                        {
                          name: "Allocated Tab",
                          value: "Allocated by D2Z"
                        },*/
                        {
                          name: "In Transit Tab",
                          value: "In Transit"
                        },
                  /*      {
                          name: "Pro Active Tab",
                          value: "ProActive CS"
                        },*/
                        {
                          name: "Inquiry Tab",
                          value: "Inquiry"
                        },
                        {
                          name: "Delivered Tab",
                          value: "Delivered"
                        },
               /*         {
                          name: "Returning Tab",
                          value: "Returning"
                        },*/
                        {
                          name: "Returned Tab",
                          value: "Returned"
                        }
                    ]
                }
              },
              {
                headerName: "Handling",
                field: "handling",
                width: 160,
                cellEditorFramework: DropDownEditor,
                editable:true,
                cellEditorParams : {
                    options: [
                      {
                        name: "David",
                        value: "David"
                      },
                      {
                        name: "Nirmal",
                        value: "Nirmal"
                      },
                      {
                        name: "Bala",
                        value: "Bala"
                      },
                      {
                        name: "Mary-Ann",
                        value: "Mary-Ann"
                      },
                      {
                        name: "Chris",
                        value: "Chris"
                      },
                       {
              name: "Rajkamal",
              value: "Rajkamal"
            },
             {
              name: "Hope",
              value: "Hope"
            }
                    ]
                }
              },
              {
                headerName: "Receiver Name",
                field: "receiverName",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Receiver Address",
                field: "receiverAddress",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Phone Number",
                field: "phoneNumber",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Suburb",
                field: "suburb",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "State",
                field: "state",
                width: 150,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Postcode",
                field: "postcode",
                width: 150,
                hide: true,
                suppressToolPanel: true
              }
            ]; 


            //  Consignment Message Screen
            this.gridOptionsMsg = <GridOptions>{ rowSelection: "multiple" };
            this.rowDataReturns = []
            this.gridOptionsMsg.columnDefs = [
                {
                  headerName: "Reference Number",
                  field: "reference_number",
                  width: 180
                },
                {
                headerName: "Article ID",
                field: "articleID",
                width: 170,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Airway Bill",
                field: "airwayBill",
                width: 100,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Broker Name",
                field: "broker_Name",
                width: 120,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Carrier",
                field: "carrier",
                width: 100,
                hide: true,
                suppressToolPanel: true
              },
              {
                headerName: "Actual Status",
                field: "status",
                width: 350,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorParams: {maxLength: 500}
              },
              {
                headerName: "Mapped Status Timestamp",
                field: "updated_Timestamp",
                width: 190
              },
              {
                headerName: "Actual Status Timestamp",
                field: "status_Timestamp",
                width: 220
              },
              {
                headerName: "User",
                field: "handling",
                width: 150
              },
              {
                headerName: "Comments",
                field: "comments",
                width: 1000,
                cellEditor: 'agLargeTextCellEditor',
                cellEditorParams: {maxLength: 1200}
              }
              ]; 
  };

    assign(params) {
      this.csSystemSelectedVal = null;
      this.actionVal = null;
      this.handlingVal = params.data.carrier.carrier;
      this.selectedHandling = null;
      console.log(params.data.reference_number);
      let reference_number = params.data.reference_number;
      console.log(params.data)
      this.csSystemSelectedVal = params.data;
      this.userMessage = this.consigmentUploadService.userMessage;
      console.log(this.userMessage);
      console.log(this.userMessage.userName);
      this.spinner.show();
      $('#msgModal').modal('show');
      this.customerServiceForm.controls['reference_number'].setValue(params.data.reference_number);
      this.customerServiceForm.controls['barcodelabelNumber'].setValue(params.data.barcodelabelNumber);
      this.customerServiceForm.controls['articleID'].setValue(params.data.articleID);
      this.customerServiceForm.controls['dateAllocated'].setValue(params.data.dateAllocated);
      this.customerServiceForm.controls['broker_Name'].setValue(params.data.broker_Name);
      this.customerServiceForm.controls['carrier'].setValue(params.data.carrier);
      this.customerServiceForm.controls['receiverName'].setValue(params.data.receiverName);
      this.customerServiceForm.controls['receiverAddress'].setValue(params.data.receiverAddress);
      this.customerServiceForm.controls['phoneNumber'].setValue(params.data.phoneNumber);
      this.customerServiceForm.controls['suburb'].setValue(params.data.suburb);
      this.customerServiceForm.controls['state'].setValue(params.data.state);
      this.customerServiceForm.controls['postcode'].setValue(params.data.postcode);
      this.customerServiceForm.controls['user'].setValue(this.userMessage.userName);
      this.selectedAction = params.data.systemStatus;
      this.selectedHandling = params.data.handling;
      console.log(this.selectedAction+" : "+this.selectedHandling)
      if(reference_number){
        this.consigmentUploadService.csDetailsHist(reference_number, (resp) => {
          this.spinner.hide();
          this.rowDataMsg = resp;
          setTimeout(() => {this.spinner.hide()}, 5000);
        });
      };
    };

  csTrackerApi(CSstatus, reference_number_array){
      console.log(CSstatus);
      this.spinner.show();
      console.log("Main Screen Initialization");
      this.userMessage = this.consigmentUploadService.userMessage;
      console.log("Login Details");
      console.log(this.userMessage.brokerUserName);
      this.consigmentUploadService.CSTrackDetails(CSstatus, reference_number_array, this.userMessage.brokerUserName, (resp) => {
          this.spinner.hide();
          if(CSstatus == ''){
              this.rowDataMaster = resp;
          }else if(CSstatus === 'Data received by D2Z'){
              this.rowDataReceived = resp;
          }else if(CSstatus === 'Allocated by D2Z'){
              this.rowDataAllocated = resp;
          }else if(CSstatus === 'Collected by D2Z'){
            this.gridOptionsReceived = resp;
          }else if(CSstatus === 'In Transit'){
              this.rowDataTransit = resp;
          }else if(CSstatus === 'ProActive CS'){
              this.rowDataProactive = resp;
          }else if(CSstatus === 'Inquiry'){
              this.rowDataInquiry = resp;
          }else if(CSstatus === 'Delivered'){
            this.rowDataDelivered = resp;
          }else if(CSstatus === 'DELIVERY ISSUE'){
            this.rowDataReturns = resp;
          }else if(CSstatus === 'Returning'){
            this.rowDataReturns = resp;
          }else if(CSstatus === 'Returned'){
            this.rowDataReturned = resp;
          }else if(CSstatus === 'Resent'){
            this.rowDataResent = resp;
          }else if(CSstatus === 'LIT'){
            this.rowDataResent = resp;
          }
        setTimeout(() => {this.spinner.hide()}, 5000);
      });
  };

  csTrackerDateRangeApi(CSstatus, fromDate, toDate){
    console.log(CSstatus);
    this.spinner.show();
    console.log("Main Screen Initialization");
    this.userMessage = this.consigmentUploadService.userMessage;
    console.log("Login Details");
    console.log(this.userMessage.brokerUserName);
    this.consigmentUploadService.CSTrackDateDetails(CSstatus, fromDate, toDate, this.userMessage.brokerUserName, (resp) => {
        this.spinner.hide();
        if(CSstatus == ''){
            this.rowDataMaster = resp;
        }
      setTimeout(() => {this.spinner.hide()}, 5000);
    });
};

  csTrackerStatusApi(CSstatus, reference_number_array){
    console.log(CSstatus);
    this.spinner.show();
    this.userMessage = this.consigmentUploadService.userMessage;
    console.log(this.userMessage.brokerUserName);
    this.consigmentUploadService.csDetailsStatusList(CSstatus, reference_number_array, this.userMessage.brokerUserName, (resp) => {
        this.spinner.hide();
        if(CSstatus === 'ProActive CS'){
            this.rowDataProactive = resp;
        }else if(CSstatus === 'Inquiry'){
            this.rowDataInquiry = resp;
        }
      setTimeout(() => {this.spinner.hide()}, 5000);
    });
  };

  searchMasterData(){
    console.log(this.trackingPrintForm.value);
    console.log(this.trackingPrintForm.value.refNum);
    console.log(this.fromDate);
    console.log(this.toDate);
    this.errorMsg = '';
    if(this.trackingPrintForm.value.refNum){
      this.CSstatus = '';
      this.csTrackerApi(this.CSstatus, this.trackingPrintForm.value.refNum);
    }else if(this.fromDate && this.toDate){
      this.CSstatus = '';
      this.csTrackerDateRangeApi(this.CSstatus, this.fromDate, this.toDate);
    }else{
      this.errorMsg = "Reference Number or From Date/To Date is Mandatory";
    }
  };


  ngOnInit() {
      this.spinner.show();
      this.CSstatus = '';
      this.reference_number_array = '';
      document.getElementById("comments")["value"] = '';
      this.csTrackerApi(this.CSstatus, this.reference_number_array);
      this.handlingDropdown = [
            {
              name: "",
              value: ""
            },
            {
              name: "David",
              value: "David"
            },
            {
              name: "Nirmal",
              value: "Nirmal"
            },
            {
              name: "Bala",
              value: "Bala"
            },
            {
              name: "Mary-Ann",
              value: "Mary-Ann"
            },
            {
              name: "Chris",
              value: "Chris"
            },
             {
              name: "Rajkamal",
              value: "Rajkamal"
            },
             {
              name: "Hope",
              value: "Hope"
            }
      ];

      this.actionDropdown = [
                          {
                            name: "",
                            value: ""
                          },
                      /*    {
                            name: "Data Received Tab",
                            value: "Data received by D2Z"
                          },
                          {
                            name: "Allocated Tab",
                            value: "Allocated by D2Z"
                          },*/
                          // {
                          //   name: "In Transit Tab",
                          //   value: "In Transit"
                          // },
                          {
                            name: "Pro Active Tab",
                            value: "ProActive CS"
                          },
                          {
                            name: "Inquiry Tab",
                            value: "Inquiry"
                          },
                          {
                            name: "Delivered Tab",
                            value: "Delivered"
                          },
                      /*    {
                            name: "Returning Tab",
                            value: "Returning"
                          },*/
                          {
                            name: "Returned Tab",
                            value: "Returned"
                          },
                          // {
                          //   name: "Resent Tab",
                          //   value: "Resent"
                          // }
      ];

  };

  menu_click(value){
    console.log(value)
    this.reference_number_array = '';
    if (value === 1) {
      this.CSstatus = '';
      this.csTrackerApi(this.CSstatus, this.reference_number_array); 
    } else if (value === 2) {
    //  this.CSstatus = 'Data received by D2Z';   
    this.CSstatus = 'Collected by D2Z';
      this.csTrackerApi(this.CSstatus, this.reference_number_array); 
    } else if (value === 3) {
      this.CSstatus = 'Allocated by D2Z';    
      this.csTrackerApi(this.CSstatus, this.reference_number_array);
    } else if (value === 4) {
      this.CSstatus = 'In Transit';  
      this.csTrackerApi(this.CSstatus, this.reference_number_array);    
    }else if (value === 5) {
      this.CSstatus = 'ProActive CS';
      this.csTrackerApi(this.CSstatus, this.reference_number_array);      
      // this.csTrackerStatusApi(this.CSstatus, this.reference_number_array);  
    }else if (value === 6) {
      this.CSstatus = 'Inquiry'; 
      this.csTrackerApi(this.CSstatus, this.reference_number_array);  
      // this.csTrackerStatusApi(this.CSstatus, this.reference_number_array);     
    }else if (value === 7) {
      this.CSstatus = 'Delivered';    
      this.csTrackerApi(this.CSstatus, this.reference_number_array);
    }else if (value === 8) {
    //  this.CSstatus = 'Returning';
    this.CSstatus = 'DELIVERY ISSUE';
      this.csTrackerApi(this.CSstatus, this.reference_number_array);      
    }else if (value === 9) {
      this.CSstatus = 'Returned';
      this.csTrackerApi(this.CSstatus, this.reference_number_array);      
    }else if (value === 10) {
      this.CSstatus = 'Resent';
      this.csTrackerApi(this.CSstatus, this.reference_number_array);      
    }else if (value === 11) {
      this.CSstatus = 'LIT';
      this.csTrackerApi(this.CSstatus, this.reference_number_array);      
    }else{
      this.CSstatus = '';    
      this.reference_number_array = '';
    }

  };

  csLogOut(){
    console.log("Clicked On Log Out")
    this.pageSwitch = "/home";
  }

  searchConsignemnt(){
    console.log("Consignment Clicked")
    console.log("Carrier -->  "+ this.carrierVal + "Status ---> "+ this.statusVal +" Form Date ---> "+ this.fromDate + 
    " To Data  -->" + this.toDate )
  };

  onCarrierChange(event){
    this.carrierVal = event.value ? event.value.value : '';
  };

  onStatusChange(event){
    this.statusVal = event.value ? event.value.value : '';
    console.log(this.statusVal);
  };

  onHandlingChange(event){
    this.handlingVal = event.value ? event.value.value : '';
    console.log(this.handlingVal);
  };

   onActionChange(event){
    this.actionVal = event.value ? event.value.value : '';
    console.log(this.actionVal);
  };

  FromDateChange(event){
    var str = event.target.value;
    var date = new Date(str),
          mnth = ("0" + (date.getMonth()+1)).slice(-2),
          day  = ("0" + date.getDate()).slice(-2);
     this.fromDate = [ date.getFullYear(), mnth, day ].join("-");
  };

  ToDateChange(event){
    var str = event.target.value;
    var date = new Date(str),
          mnth = ("0" + (date.getMonth()+1)).slice(-2),
          day  = ("0" + date.getDate()).slice(-2);
     this.toDate = [ date.getFullYear(), mnth, day ].join("-");
  };

  updateStatus(){
    var selectedRows = this.gridOptionsMaster.api.getSelectedRows();
    this.customerTrackerList = [];
    this.moveValidFlag = true;
    this.errorMsg = null;
    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let systemStatus = 'systemStatus';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling'; 
    let status_Timestamp = 'status_Timestamp'; 
    let comments = 'comments';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedRows.length > 0){
            for (var fieldVal in selectedRows) {
                var fieldObj = selectedRows[fieldVal];
                if(fieldObj.action || fieldObj.handling){
                      if(fieldObj.action){
                          // console.log("Inside Move Section")
                          //     if(fieldObj.status === "Allocated by D2Z" && (fieldObj.action === "ProActive CS" || fieldObj.action === "Inquiry" ) ){
                          //         this.moveValidFlag = true;
                          //     }else if(fieldObj.status === "In Transit" && (fieldObj.action === "ProActive CS" || fieldObj.action === "Inquiry" || fieldObj.action === "Inquiry" ) ){
                          //       this.moveValidFlag = true;
                          //     }else if(fieldObj.status === "ProActive CS" && (fieldObj.action === "Delivered" || fieldObj.action === "Inquiry" ||  fieldObj.action === "Returns" ) ){
                          //       this.moveValidFlag = true;
                          //     }else if(fieldObj.status === "Inquiry" && (fieldObj.action === "Delivered" || fieldObj.action === "Returns" ) ){
                          //       this.moveValidFlag = true;
                          //     }else if(fieldObj.status === "Delivered" && (fieldObj.action === "ProActive CS" || fieldObj.action === "Inquiry" || fieldObj.action === "Returns" ) ){
                          //       this.moveValidFlag = true;
                          //     }else{
                          //       this.moveValidFlag = false;
                          //         if( (fieldObj.status === "Allocated by D2Z" || fieldObj.status === "In Transit" )  && !(fieldObj.action === "ProActive CS" || fieldObj.action === "Inquiry" ) ){
                          //           this.errorMsg = "Proactive CS or Inquiry Movement Alone is Allowed";
                          //         }else if( (fieldObj.status === "ProActive CS") && !(fieldObj.action === "Delivered" || fieldObj.action === "Inquiry" ||  fieldObj.action === "Returns" ) ){
                          //           this.errorMsg = " Inquiry or Delivered or Returns & Issues Movement Alone is Allowed";
                          //         }else if( (fieldObj.status === "Inquiry") && !(fieldObj.action === "Delivered" || fieldObj.action === "Returns" ) ){
                          //           this.errorMsg = " Delivered or Returns & Issues Movement Alone is Allowed";
                          //         }
                          //       break;
                          //     }

                              // if(this.moveValidFlag){
                                    var csObj = (
                                      csObj={}, 
                                      csObj[reference_number]= fieldObj.reference_number != undefined ? fieldObj.reference_number : '', csObj,
                                      csObj[articleID]= fieldObj.articleID != undefined ? fieldObj.articleID : '', csObj,
                                      csObj[airwayBill]= fieldObj.airwayBill != undefined ? fieldObj.airwayBill : '', csObj,
                                      csObj[user_id]= fieldObj.user_id != undefined ? fieldObj.user_id : '', csObj,
                                      csObj[broker_Name]= fieldObj.broker_Name != undefined ? fieldObj.broker_Name : '', csObj,
                                      csObj[service_type]= fieldObj.service_type != undefined ? fieldObj.service_type : '', csObj,
                                      csObj[carrier]= fieldObj.carrier != undefined ? fieldObj.carrier : '', csObj,
                                      csObj[systemStatus]= fieldObj.systemStatus != undefined ? fieldObj.systemStatus : '', csObj,
                                      csObj[action]= fieldObj.action != undefined ? fieldObj.action : null, csObj,
                                      csObj[created_Timestamp]= fieldObj.created_Timestamp != undefined ? fieldObj.created_Timestamp : '', csObj,
                                      csObj[handling]= fieldObj.handling != undefined ? fieldObj.handling : null, csObj,
                                      csObj[status_Timestamp]= fieldObj.status_Timestamp != undefined ? fieldObj.status_Timestamp : '', csObj,
                                      csObj[comments]= fieldObj.comments != undefined ? fieldObj.comments : null, csObj,
                                      csObj[statusUpdateFlag]= fieldObj.action ? true: false, csObj,
                                      csObj[handlingUpdateFlag]= fieldObj.handling ? true: false, csObj,
                                      csObj[commentsUpdateFlag]= false, csObj
                                    );
                                    this.customerTrackerList.push(csObj);
                                    console.log( this.customerTrackerList);
                              // }else{
                              //       this.errorMsg = "**Please change the Status to proceed further";
                              // }
                      }else if(fieldObj.handling){
                              console.log("Inside Handling Move Section")
                                var csObj = (
                                  csObj={}, 
                                  csObj[reference_number]= fieldObj.reference_number != undefined ? fieldObj.reference_number : '', csObj,
                                  csObj[articleID]= fieldObj.articleID != undefined ? fieldObj.articleID : '', csObj,
                                  csObj[airwayBill]= fieldObj.airwayBill != undefined ? fieldObj.airwayBill : '', csObj,
                                  csObj[user_id]= fieldObj.user_id != undefined ? fieldObj.user_id : '', csObj,
                                  csObj[broker_Name]= fieldObj.broker_Name != undefined ? fieldObj.broker_Name : '', csObj,
                                  csObj[service_type]= fieldObj.service_type != undefined ? fieldObj.service_type : '', csObj,
                                  csObj[carrier]= fieldObj.carrier != undefined ? fieldObj.carrier : '', csObj,
                                  csObj[systemStatus]= fieldObj.systemStatus != undefined ? fieldObj.systemStatus : '', csObj,
                                  csObj[action]= fieldObj.action != undefined ? fieldObj.action : fieldObj.systemStatus, csObj,
                                  csObj[created_Timestamp]= fieldObj.created_Timestamp != undefined ? fieldObj.created_Timestamp : '', csObj,
                                  csObj[handling]= fieldObj.handling != undefined ? fieldObj.handling : '', csObj,
                                  csObj[status_Timestamp]= fieldObj.status_Timestamp != undefined ? fieldObj.status_Timestamp : '', csObj,
                                  csObj[comments]= fieldObj.comments != undefined ? fieldObj.comments : null, csObj,
                                  csObj[statusUpdateFlag]= fieldObj.action ? true: false, csObj,
                                  csObj[handlingUpdateFlag]= fieldObj.handling ? true: false, csObj,
                                  csObj[commentsUpdateFlag]= false, csObj
                                );
                                this.customerTrackerList.push(csObj);
                                console.log( this.customerTrackerList);
                      }
                  }
            };

            if(this.customerTrackerList.length > 0){
              this.spinner.show();
                this.consigmentUploadService.updateCSstatus(this.customerTrackerList, (resp) => {
                  this.spinner.hide();
                  if(resp.error){
                    this.successMsg = resp.error.errorMessage;
                  }else{
                    this.successMsg = resp.message;
                    this.errorMsg = '';
                  }
                  this.CSstatus = '';
                  this.reference_number_array = '';
                  this.csTrackerApi(this.CSstatus, this.reference_number_array); 
                  $('#csModal').modal('show');
                })
            };
      
      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      }  
  };

  updateReceivedStatus(){
    var selectedReceivedRows = this.gridOptionsReceived.api.getSelectedRows();
    this.customerReceivedList = [];
    this.errorMsg = null;

    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let barcodelabelNumber = 'barcodelabelNumber';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let status = 'status';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedReceivedRows.length > 0){
      for (var fieldReceivedVal in selectedReceivedRows) {
        var fieldReceivedObj = selectedReceivedRows[fieldReceivedVal];

        if(fieldReceivedObj.action){
            var receivedObj = (
              receivedObj={}, 
              receivedObj[reference_number]= fieldReceivedObj.reference_number != undefined ? fieldReceivedObj.reference_number : '', receivedObj,
              receivedObj[barcodelabelNumber]= fieldReceivedObj.barcodelabelNumber != undefined ? fieldReceivedObj.barcodelabelNumber : '', receivedObj,
              receivedObj[articleID]= fieldReceivedObj.articleID != undefined ? fieldReceivedObj.articleID : '', receivedObj,
              receivedObj[airwayBill]= fieldReceivedObj.airwayBill != undefined ? fieldReceivedObj.airwayBill : '', receivedObj,
              receivedObj[user_id]= fieldReceivedObj.user_id != undefined ? fieldReceivedObj.user_id : '', receivedObj,
              receivedObj[broker_Name]= fieldReceivedObj.broker_Name != undefined ? fieldReceivedObj.broker_Name : '', receivedObj,
              receivedObj[service_type]= fieldReceivedObj.service_type != undefined ? fieldReceivedObj.service_type : '', receivedObj,
              receivedObj[carrier]= fieldReceivedObj.carrier != undefined ? fieldReceivedObj.carrier : '', receivedObj,
              receivedObj[status]= fieldReceivedObj.status != undefined ? fieldReceivedObj.status : '', receivedObj,
              receivedObj[action]= fieldReceivedObj.action != undefined ? fieldReceivedObj.action : '', receivedObj,
              receivedObj[created_Timestamp]= fieldReceivedObj.created_Timestamp != undefined ? fieldReceivedObj.created_Timestamp : '', receivedObj,
              receivedObj[handling]= fieldReceivedObj.handling != undefined ? fieldReceivedObj.handling : '', receivedObj,
              receivedObj[statusUpdateFlag]= receivedObj.action ? true: false, receivedObj,
              receivedObj[handlingUpdateFlag]= receivedObj.handling ? true: false, receivedObj,
              receivedObj[commentsUpdateFlag]= false, receivedObj
            );
            this.customerReceivedList.push(receivedObj);
            console.log( this.customerReceivedList);
          }else if(fieldReceivedObj.handling){
            var receivedObj = (
              receivedObj={}, 
              receivedObj[reference_number]= fieldReceivedObj.reference_number != undefined ? fieldReceivedObj.reference_number : '', receivedObj,
              receivedObj[barcodelabelNumber]= fieldReceivedObj.barcodelabelNumber != undefined ? fieldReceivedObj.barcodelabelNumber : '', receivedObj,
              receivedObj[articleID]= fieldReceivedObj.articleID != undefined ? fieldReceivedObj.articleID : '', receivedObj,
              receivedObj[airwayBill]= fieldReceivedObj.airwayBill != undefined ? fieldReceivedObj.airwayBill : '', receivedObj,
              receivedObj[user_id]= fieldReceivedObj.user_id != undefined ? fieldReceivedObj.user_id : '', receivedObj,
              receivedObj[broker_Name]= fieldReceivedObj.broker_Name != undefined ? fieldReceivedObj.broker_Name : '', receivedObj,
              receivedObj[service_type]= fieldReceivedObj.service_type != undefined ? fieldReceivedObj.service_type : '', receivedObj,
              receivedObj[carrier]= fieldReceivedObj.carrier != undefined ? fieldReceivedObj.carrier : '', receivedObj,
              receivedObj[status]= fieldReceivedObj.status != undefined ? fieldReceivedObj.status : '', receivedObj,
              receivedObj[action]= fieldReceivedObj.status != undefined ? fieldReceivedObj.status : '', receivedObj,
              receivedObj[created_Timestamp]= fieldReceivedObj.created_Timestamp != undefined ? fieldReceivedObj.created_Timestamp : '', receivedObj,
              receivedObj[handling]= fieldReceivedObj.handling != undefined ? fieldReceivedObj.handling : '', receivedObj,
              receivedObj[statusUpdateFlag]= receivedObj.action ? true: false, receivedObj,
              receivedObj[handlingUpdateFlag]= receivedObj.handling ? true: false, receivedObj,
              receivedObj[commentsUpdateFlag]= false, receivedObj
            );
            this.customerReceivedList.push(receivedObj);
            console.log( this.customerReceivedList);
          }else{
            this.errorMsg = "**Please change the Status to proceed further";
          }
        };
        if(this.customerReceivedList.length > 0){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.customerReceivedList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = 'Data received by D2Z';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array); 
              $('#csModal').modal('show');
            })
        };
      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      }  
  };

  updateAllocatedStatus(){
    var selectedAllocatedRows = this.gridOptionsLIT.api.getSelectedRows();
    this.customerAllocatedList = [];
    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let barcodelabelNumber = 'barcodelabelNumber';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let status = 'status';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedAllocatedRows.length > 0){
      for (var fieldAllocatedVal in selectedAllocatedRows) {
        var fieldAllocatedObj = selectedAllocatedRows[fieldAllocatedVal];

        if(fieldAllocatedObj.action){
              var allocatedObj = (
                    allocatedObj={}, 
                    allocatedObj[reference_number]= fieldAllocatedObj.reference_number != undefined ? fieldAllocatedObj.reference_number : '', allocatedObj,
                    allocatedObj[barcodelabelNumber]= fieldAllocatedObj.barcodelabelNumber != undefined ? fieldAllocatedObj.barcodelabelNumber : '', allocatedObj,
                    allocatedObj[articleID]= fieldAllocatedObj.articleID != undefined ? fieldAllocatedObj.articleID : '', allocatedObj,
                    allocatedObj[airwayBill]= fieldAllocatedObj.airwayBill != undefined ? fieldAllocatedObj.airwayBill : '', allocatedObj,
                    allocatedObj[user_id]= fieldAllocatedObj.user_id != undefined ? fieldAllocatedObj.user_id : '', allocatedObj,
                    allocatedObj[broker_Name]= fieldAllocatedObj.broker_Name != undefined ? fieldAllocatedObj.broker_Name : '', allocatedObj,
                    allocatedObj[service_type]= fieldAllocatedObj.service_type != undefined ? fieldAllocatedObj.service_type : '', allocatedObj,
                    allocatedObj[carrier]= fieldAllocatedObj.carrier != undefined ? fieldAllocatedObj.carrier : '', allocatedObj,
                    allocatedObj[status]= fieldAllocatedObj.status != undefined ? fieldAllocatedObj.status : '', allocatedObj,
                    allocatedObj[action]= fieldAllocatedObj.action != undefined ? fieldAllocatedObj.action : '', allocatedObj,
                    allocatedObj[created_Timestamp]= fieldAllocatedObj.created_Timestamp != undefined ? fieldAllocatedObj.created_Timestamp : '', allocatedObj,
                    allocatedObj[handling]= fieldAllocatedObj.handling != undefined ? fieldAllocatedObj.handling : '', allocatedObj,
                    allocatedObj[statusUpdateFlag]= allocatedObj.action ? true: false, allocatedObj,
                    allocatedObj[handlingUpdateFlag]= allocatedObj.handling ? true: false, allocatedObj,
                    allocatedObj[commentsUpdateFlag]= false, allocatedObj
              );
              this.customerAllocatedList.push(allocatedObj);
              console.log( this.customerAllocatedList);
          }else if(fieldAllocatedObj.handling){
               var allocatedObj = (
                    allocatedObj={}, 
                    allocatedObj[reference_number]= fieldAllocatedObj.reference_number != undefined ? fieldAllocatedObj.reference_number : '', allocatedObj,
                    allocatedObj[barcodelabelNumber]= fieldAllocatedObj.barcodelabelNumber != undefined ? fieldAllocatedObj.barcodelabelNumber : '', allocatedObj,
                    allocatedObj[articleID]= fieldAllocatedObj.articleID != undefined ? fieldAllocatedObj.articleID : '', allocatedObj,
                    allocatedObj[airwayBill]= fieldAllocatedObj.airwayBill != undefined ? fieldAllocatedObj.airwayBill : '', allocatedObj,
                    allocatedObj[user_id]= fieldAllocatedObj.user_id != undefined ? fieldAllocatedObj.user_id : '', allocatedObj,
                    allocatedObj[broker_Name]= fieldAllocatedObj.broker_Name != undefined ? fieldAllocatedObj.broker_Name : '', allocatedObj,
                    allocatedObj[service_type]= fieldAllocatedObj.service_type != undefined ? fieldAllocatedObj.service_type : '', allocatedObj,
                    allocatedObj[carrier]= fieldAllocatedObj.carrier != undefined ? fieldAllocatedObj.carrier : '', allocatedObj,
                    allocatedObj[status]= fieldAllocatedObj.status != undefined ? fieldAllocatedObj.status : '', allocatedObj,
                    allocatedObj[action]= fieldAllocatedObj.status != undefined ? fieldAllocatedObj.status : '', allocatedObj,
                    allocatedObj[created_Timestamp]= fieldAllocatedObj.created_Timestamp != undefined ? fieldAllocatedObj.created_Timestamp : '', allocatedObj,
                    allocatedObj[handling]= fieldAllocatedObj.handling != undefined ? fieldAllocatedObj.handling : '', allocatedObj,
                    allocatedObj[statusUpdateFlag]= allocatedObj.action ? true: false, allocatedObj,
                    allocatedObj[handlingUpdateFlag]= allocatedObj.handling ? true: false, allocatedObj,
                    allocatedObj[commentsUpdateFlag]= false, allocatedObj
              );
              this.customerAllocatedList.push(allocatedObj);
              console.log( this.customerAllocatedList);
          }else{
            this.errorMsg = "**Please change the Status to proceed further";
          }
        };
        if(this.customerAllocatedList.length > 0){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.customerAllocatedList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = 'Allocated by D2Z';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array); 
              $('#csModal').modal('show');
            })
        };
      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      }  
  };

  updateIntransistStatus(){
    var selectedIntransistRows = this.gridOptionsTransit.api.getSelectedRows();
    this.customerIntransistList = [];
    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let barcodelabelNumber = 'barcodelabelNumber';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let status = 'status';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedIntransistRows.length > 0){
      for (var fieldIntransistVal in selectedIntransistRows) {
        var fieldIntransistObj = selectedIntransistRows[fieldIntransistVal];
        if(fieldIntransistObj.action){
                var intransistdObj = (
                  intransistdObj={}, 
                  intransistdObj[reference_number]= fieldIntransistObj.reference_number != undefined ? fieldIntransistObj.reference_number : '', intransistdObj,
                  intransistdObj[barcodelabelNumber]= fieldIntransistObj.barcodelabelNumber != undefined ? fieldIntransistObj.barcodelabelNumber : '', intransistdObj,
                  intransistdObj[articleID]= fieldIntransistObj.articleID != undefined ? fieldIntransistObj.articleID : '', intransistdObj,
                  intransistdObj[airwayBill]= fieldIntransistObj.airwayBill != undefined ? fieldIntransistObj.airwayBill : '', intransistdObj,
                  intransistdObj[user_id]= fieldIntransistObj.user_id != undefined ? fieldIntransistObj.user_id : '', intransistdObj,
                  intransistdObj[broker_Name]= fieldIntransistObj.broker_Name != undefined ? fieldIntransistObj.broker_Name : '', intransistdObj,
                  intransistdObj[service_type]= fieldIntransistObj.service_type != undefined ? fieldIntransistObj.service_type : '', intransistdObj,
                  intransistdObj[carrier]= fieldIntransistObj.carrier != undefined ? fieldIntransistObj.carrier : '', intransistdObj,
                  intransistdObj[status]= fieldIntransistObj.status != undefined ? fieldIntransistObj.status : '', intransistdObj,
                  intransistdObj[action]= fieldIntransistObj.action != undefined ? fieldIntransistObj.action : '', intransistdObj,
                  intransistdObj[created_Timestamp]= fieldIntransistObj.created_Timestamp != undefined ? fieldIntransistObj.created_Timestamp : '', intransistdObj,
                  intransistdObj[handling]= fieldIntransistObj.handling != undefined ? fieldIntransistObj.handling : '', intransistdObj,
                  intransistdObj[statusUpdateFlag]= intransistdObj.action ? true: false, intransistdObj,
                  intransistdObj[handlingUpdateFlag]= intransistdObj.handling ? true: false, intransistdObj,
                  intransistdObj[commentsUpdateFlag]= false, intransistdObj
                );
                this.customerIntransistList.push(intransistdObj);
                console.log( this.customerIntransistList);
          }else if(fieldIntransistObj.handling){
                var intransistdObj = (
                  intransistdObj={}, 
                  intransistdObj[reference_number]= fieldIntransistObj.reference_number != undefined ? fieldIntransistObj.reference_number : '', intransistdObj,
                  intransistdObj[barcodelabelNumber]= fieldIntransistObj.barcodelabelNumber != undefined ? fieldIntransistObj.barcodelabelNumber : '', intransistdObj,
                  intransistdObj[articleID]= fieldIntransistObj.articleID != undefined ? fieldIntransistObj.articleID : '', intransistdObj,
                  intransistdObj[airwayBill]= fieldIntransistObj.airwayBill != undefined ? fieldIntransistObj.airwayBill : '', intransistdObj,
                  intransistdObj[user_id]= fieldIntransistObj.user_id != undefined ? fieldIntransistObj.user_id : '', intransistdObj,
                  intransistdObj[broker_Name]= fieldIntransistObj.broker_Name != undefined ? fieldIntransistObj.broker_Name : '', intransistdObj,
                  intransistdObj[service_type]= fieldIntransistObj.service_type != undefined ? fieldIntransistObj.service_type : '', intransistdObj,
                  intransistdObj[carrier]= fieldIntransistObj.carrier != undefined ? fieldIntransistObj.carrier : '', intransistdObj,
                  intransistdObj[status]= fieldIntransistObj.status != undefined ? fieldIntransistObj.status : '', intransistdObj,
                  intransistdObj[action]= fieldIntransistObj.status != undefined ? fieldIntransistObj.status : '', intransistdObj,
                  intransistdObj[created_Timestamp]= fieldIntransistObj.created_Timestamp != undefined ? fieldIntransistObj.created_Timestamp : '', intransistdObj,
                  intransistdObj[handling]= fieldIntransistObj.handling != undefined ? fieldIntransistObj.handling : '', intransistdObj,
                  intransistdObj[statusUpdateFlag]= intransistdObj.action ? true: false, intransistdObj,
                  intransistdObj[handlingUpdateFlag]= intransistdObj.handling ? true: false, intransistdObj,
                  intransistdObj[commentsUpdateFlag]= false, intransistdObj
                );
                this.customerIntransistList.push(intransistdObj);
                console.log( this.customerIntransistList);
          }else{
            this.errorMsg = "**Please change the Status to proceed further";
          }
        };

        if(this.customerIntransistList.length > 0){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.customerIntransistList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = 'In Transit';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array);  
              $('#csModal').modal('show');
            })
        };
      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      } 
  };

  updateProActiveStatus(){
    var selectedProActiveRows = this.gridOptionsProactive.api.getSelectedRows();
    this.customerProactiveList = [];
    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let barcodelabelNumber = 'barcodelabelNumber';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let status = 'status';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedProActiveRows.length > 0){
      for (var fieldProactivetVal in selectedProActiveRows) {
        var fieldProactiveObj = selectedProActiveRows[fieldProactivetVal];
        if(fieldProactiveObj.action){
              var proActiveObj = (
                proActiveObj={}, 
                proActiveObj[reference_number]= fieldProactiveObj.reference_number != undefined ? fieldProactiveObj.reference_number : '', proActiveObj,
                proActiveObj[barcodelabelNumber]= fieldProactiveObj.barcodelabelNumber != undefined ? fieldProactiveObj.barcodelabelNumber : '', proActiveObj,
                proActiveObj[articleID]= fieldProactiveObj.articleID != undefined ? fieldProactiveObj.articleID : '', proActiveObj,
                proActiveObj[airwayBill]= fieldProactiveObj.airwayBill != undefined ? fieldProactiveObj.airwayBill : '', proActiveObj,
                proActiveObj[user_id]= fieldProactiveObj.user_id != undefined ? fieldProactiveObj.user_id : '', proActiveObj,
                proActiveObj[broker_Name]= fieldProactiveObj.broker_Name != undefined ? fieldProactiveObj.broker_Name : '', proActiveObj,
                proActiveObj[service_type]= fieldProactiveObj.service_type != undefined ? fieldProactiveObj.service_type : '', proActiveObj,
                proActiveObj[carrier]= fieldProactiveObj.carrier != undefined ? fieldProactiveObj.carrier : '', proActiveObj,
                proActiveObj[status]= fieldProactiveObj.status != undefined ? fieldProactiveObj.status : '', proActiveObj,
                proActiveObj[action]= fieldProactiveObj.action != undefined ? fieldProactiveObj.action : '', proActiveObj,
                proActiveObj[created_Timestamp]= fieldProactiveObj.created_Timestamp != undefined ? fieldProactiveObj.created_Timestamp : '', proActiveObj,
                proActiveObj[handling]= fieldProactiveObj.handling != undefined ? fieldProactiveObj.handling : '', proActiveObj,
                proActiveObj[statusUpdateFlag]= proActiveObj.action ? true: false, proActiveObj,
                proActiveObj[handlingUpdateFlag]= proActiveObj.handling ? true: false, proActiveObj,
                proActiveObj[commentsUpdateFlag]= false, proActiveObj
              );
              this.customerProactiveList.push(proActiveObj);
              console.log( this.customerProactiveList);
          }else if(fieldProactiveObj.handling){
                var proActiveObj = (
                proActiveObj={}, 
                proActiveObj[reference_number]= fieldProactiveObj.reference_number != undefined ? fieldProactiveObj.reference_number : '', proActiveObj,
                proActiveObj[barcodelabelNumber]= fieldProactiveObj.barcodelabelNumber != undefined ? fieldProactiveObj.barcodelabelNumber : '', proActiveObj,
                proActiveObj[articleID]= fieldProactiveObj.articleID != undefined ? fieldProactiveObj.articleID : '', proActiveObj,
                proActiveObj[airwayBill]= fieldProactiveObj.airwayBill != undefined ? fieldProactiveObj.airwayBill : '', proActiveObj,
                proActiveObj[user_id]= fieldProactiveObj.user_id != undefined ? fieldProactiveObj.user_id : '', proActiveObj,
                proActiveObj[broker_Name]= fieldProactiveObj.broker_Name != undefined ? fieldProactiveObj.broker_Name : '', proActiveObj,
                proActiveObj[service_type]= fieldProactiveObj.service_type != undefined ? fieldProactiveObj.service_type : '', proActiveObj,
                proActiveObj[carrier]= fieldProactiveObj.carrier != undefined ? fieldProactiveObj.carrier : '', proActiveObj,
                proActiveObj[status]= fieldProactiveObj.status != undefined ? fieldProactiveObj.status : '', proActiveObj,
                proActiveObj[action]= fieldProactiveObj.status != undefined ? fieldProactiveObj.status : '', proActiveObj,
                proActiveObj[created_Timestamp]= fieldProactiveObj.created_Timestamp != undefined ? fieldProactiveObj.created_Timestamp : '', proActiveObj,
                proActiveObj[handling]= fieldProactiveObj.handling != undefined ? fieldProactiveObj.handling : '', proActiveObj,
                proActiveObj[statusUpdateFlag]= proActiveObj.action ? true: false, proActiveObj,
                proActiveObj[handlingUpdateFlag]= proActiveObj.handling ? true: false, proActiveObj,
                proActiveObj[commentsUpdateFlag]= false, proActiveObj
              );
              this.customerProactiveList.push(proActiveObj);
              console.log( this.customerProactiveList);
          }else{
            this.errorMsg = "**Please change the Status to proceed further";
          }
        };

        if(this.customerProactiveList.length > 0){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.customerProactiveList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = 'ProActive CS';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array);  
              $('#csModal').modal('show');
            })
        };
      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      } 
  };

  updateInquiryStatus(){
    var selectedInquiryRows = this.gridOptionsInquiry.api.getSelectedRows();
    this.customerInquiryList = [];
    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let barcodelabelNumber = 'barcodelabelNumber';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let status = 'status';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedInquiryRows.length > 0){
      for (var fieldInquiryVal in selectedInquiryRows) {
        var fieldInquiryObj = selectedInquiryRows[fieldInquiryVal];
        if(fieldInquiryObj.action){
              var inquiryObj = (
                inquiryObj={}, 
                inquiryObj[reference_number]= fieldInquiryObj.reference_number != undefined ? fieldInquiryObj.reference_number : '', inquiryObj,
                inquiryObj[barcodelabelNumber]= fieldInquiryObj.barcodelabelNumber != undefined ? fieldInquiryObj.barcodelabelNumber : '', inquiryObj,
                inquiryObj[articleID]= fieldInquiryObj.articleID != undefined ? fieldInquiryObj.articleID : '', inquiryObj,
                inquiryObj[airwayBill]= fieldInquiryObj.airwayBill != undefined ? fieldInquiryObj.airwayBill : '', inquiryObj,
                inquiryObj[user_id]= fieldInquiryObj.user_id != undefined ? fieldInquiryObj.user_id : '', inquiryObj,
                inquiryObj[broker_Name]= fieldInquiryObj.broker_Name != undefined ? fieldInquiryObj.broker_Name : '', inquiryObj,
                inquiryObj[service_type]= fieldInquiryObj.service_type != undefined ? fieldInquiryObj.service_type : '', inquiryObj,
                inquiryObj[carrier]= fieldInquiryObj.carrier != undefined ? fieldInquiryObj.carrier : '', inquiryObj,
                inquiryObj[status]= fieldInquiryObj.status != undefined ? fieldInquiryObj.status : '', inquiryObj,
                inquiryObj[action]= fieldInquiryObj.action != undefined ? fieldInquiryObj.action : '', inquiryObj,
                inquiryObj[created_Timestamp]= fieldInquiryObj.created_Timestamp != undefined ? fieldInquiryObj.created_Timestamp : '', inquiryObj,
                inquiryObj[handling]= fieldInquiryObj.handling != undefined ? fieldInquiryObj.handling : '', inquiryObj,
                inquiryObj[statusUpdateFlag]= inquiryObj.action ? true: false, inquiryObj,
                inquiryObj[handlingUpdateFlag]= inquiryObj.handling ? true: false, inquiryObj,
                inquiryObj[commentsUpdateFlag]= false, inquiryObj
              );
              this.customerInquiryList.push(inquiryObj);
              console.log( this.customerInquiryList);
          }else if(fieldInquiryObj.handling){
              var inquiryObj = (
                inquiryObj={}, 
                inquiryObj[reference_number]= fieldInquiryObj.reference_number != undefined ? fieldInquiryObj.reference_number : '', inquiryObj,
                inquiryObj[barcodelabelNumber]= fieldInquiryObj.barcodelabelNumber != undefined ? fieldInquiryObj.barcodelabelNumber : '', inquiryObj,
                inquiryObj[articleID]= fieldInquiryObj.articleID != undefined ? fieldInquiryObj.articleID : '', inquiryObj,
                inquiryObj[airwayBill]= fieldInquiryObj.airwayBill != undefined ? fieldInquiryObj.airwayBill : '', inquiryObj,
                inquiryObj[user_id]= fieldInquiryObj.user_id != undefined ? fieldInquiryObj.user_id : '', inquiryObj,
                inquiryObj[broker_Name]= fieldInquiryObj.broker_Name != undefined ? fieldInquiryObj.broker_Name : '', inquiryObj,
                inquiryObj[service_type]= fieldInquiryObj.service_type != undefined ? fieldInquiryObj.service_type : '', inquiryObj,
                inquiryObj[carrier]= fieldInquiryObj.carrier != undefined ? fieldInquiryObj.carrier : '', inquiryObj,
                inquiryObj[status]= fieldInquiryObj.status != undefined ? fieldInquiryObj.status : '', inquiryObj,
                inquiryObj[action]= fieldInquiryObj.status != undefined ? fieldInquiryObj.status : '', inquiryObj,
                inquiryObj[created_Timestamp]= fieldInquiryObj.created_Timestamp != undefined ? fieldInquiryObj.created_Timestamp : '', inquiryObj,
                inquiryObj[handling]= fieldInquiryObj.handling != undefined ? fieldInquiryObj.handling : '', inquiryObj,
                inquiryObj[statusUpdateFlag]= inquiryObj.action ? true: false, inquiryObj,
                inquiryObj[handlingUpdateFlag]= inquiryObj.handling ? true: false, inquiryObj,
                inquiryObj[commentsUpdateFlag]= false, inquiryObj
              );
              this.customerInquiryList.push(inquiryObj);
              console.log( this.customerInquiryList);
          }else{
            this.errorMsg = "**Please change the Status to proceed further";
          }
        };

        if(this.customerInquiryList.length > 0){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.customerInquiryList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = 'Inquiry';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array); 
              $('#csModal').modal('show');
            })
        };
      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      } 
  };

  updateDeliveredStatus(){
    var selectedDeliveredRows = this.gridOptionsDelivered.api.getSelectedRows();
    this.customeDeliveredList = [];
    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let barcodelabelNumber = 'barcodelabelNumber';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let status = 'status';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedDeliveredRows.length > 0){
      for (var fieldDeliveredVal in selectedDeliveredRows) {
        var fieldDeliveredObj = selectedDeliveredRows[fieldDeliveredVal];
        if(fieldDeliveredObj.action){
                var deliveredObj = (
                  deliveredObj={}, 
                  deliveredObj[reference_number]= fieldDeliveredObj.reference_number != undefined ? fieldDeliveredObj.reference_number : '', deliveredObj,
                  deliveredObj[barcodelabelNumber]= fieldDeliveredObj.barcodelabelNumber != undefined ? fieldDeliveredObj.barcodelabelNumber : '', deliveredObj,
                  deliveredObj[articleID]= fieldDeliveredObj.articleID != undefined ? fieldDeliveredObj.articleID : '', deliveredObj,
                  deliveredObj[airwayBill]= fieldDeliveredObj.airwayBill != undefined ? fieldDeliveredObj.airwayBill : '', deliveredObj,
                  deliveredObj[user_id]= fieldDeliveredObj.user_id != undefined ? fieldDeliveredObj.user_id : '', deliveredObj,
                  deliveredObj[broker_Name]= fieldDeliveredObj.broker_Name != undefined ? fieldDeliveredObj.broker_Name : '', deliveredObj,
                  deliveredObj[service_type]= fieldDeliveredObj.service_type != undefined ? fieldDeliveredObj.service_type : '', deliveredObj,
                  deliveredObj[carrier]= fieldDeliveredObj.carrier != undefined ? fieldDeliveredObj.carrier : '', deliveredObj,
                  deliveredObj[status]= fieldDeliveredObj.status != undefined ? fieldDeliveredObj.status : '', deliveredObj,
                  deliveredObj[action]= fieldDeliveredObj.action != undefined ? fieldDeliveredObj.action : '', deliveredObj,
                  deliveredObj[created_Timestamp]= fieldDeliveredObj.created_Timestamp != undefined ? fieldDeliveredObj.created_Timestamp : '', deliveredObj,
                  deliveredObj[handling]= fieldDeliveredObj.handling != undefined ? fieldDeliveredObj.handling : '', deliveredObj,
                  deliveredObj[statusUpdateFlag]= deliveredObj.action ? true: false, deliveredObj,
                  deliveredObj[handlingUpdateFlag]= deliveredObj.handling ? true: false, deliveredObj,
                  deliveredObj[commentsUpdateFlag]= false, deliveredObj
                );
                this.customeDeliveredList.push(deliveredObj);
                console.log( this.customeDeliveredList);
          }else if(fieldDeliveredObj.handling){
                var deliveredObj = (
                  deliveredObj={}, 
                  deliveredObj[reference_number]= fieldDeliveredObj.reference_number != undefined ? fieldDeliveredObj.reference_number : '', deliveredObj,
                  deliveredObj[barcodelabelNumber]= fieldDeliveredObj.barcodelabelNumber != undefined ? fieldDeliveredObj.barcodelabelNumber : '', deliveredObj,
                  deliveredObj[articleID]= fieldDeliveredObj.articleID != undefined ? fieldDeliveredObj.articleID : '', deliveredObj,
                  deliveredObj[airwayBill]= fieldDeliveredObj.airwayBill != undefined ? fieldDeliveredObj.airwayBill : '', deliveredObj,
                  deliveredObj[user_id]= fieldDeliveredObj.user_id != undefined ? fieldDeliveredObj.user_id : '', deliveredObj,
                  deliveredObj[broker_Name]= fieldDeliveredObj.broker_Name != undefined ? fieldDeliveredObj.broker_Name : '', deliveredObj,
                  deliveredObj[service_type]= fieldDeliveredObj.service_type != undefined ? fieldDeliveredObj.service_type : '', deliveredObj,
                  deliveredObj[carrier]= fieldDeliveredObj.carrier != undefined ? fieldDeliveredObj.carrier : '', deliveredObj,
                  deliveredObj[status]= fieldDeliveredObj.status != undefined ? fieldDeliveredObj.status : '', deliveredObj,
                  deliveredObj[action]= fieldDeliveredObj.status != undefined ? fieldDeliveredObj.status : '', deliveredObj,
                  deliveredObj[created_Timestamp]= fieldDeliveredObj.created_Timestamp != undefined ? fieldDeliveredObj.created_Timestamp : '', deliveredObj,
                  deliveredObj[handling]= fieldDeliveredObj.handling != undefined ? fieldDeliveredObj.handling : '', deliveredObj,
                  deliveredObj[statusUpdateFlag]= deliveredObj.action ? true: false, deliveredObj,
                  deliveredObj[handlingUpdateFlag]= deliveredObj.handling ? true: false, deliveredObj,
                  deliveredObj[commentsUpdateFlag]= false, deliveredObj
              );
              this.customeDeliveredList.push(deliveredObj);
              console.log( this.customeDeliveredList);
          }else{
            this.errorMsg = "**Please change the Status to proceed further";
          }
        };

        if(this.customeDeliveredList.length > 0){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.customeDeliveredList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = 'Delivered';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array); 
              $('#csModal').modal('show');
            })
        };
      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      } 
  };

  updateReturnsStatus(){
    console.log("Clicked Returns");
    var selectedReturnsRows = this.gridOptionsReturns.api.getSelectedRows();
    this.customeReturnsList = [];
    console.log(selectedReturnsRows.length);
    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let barcodelabelNumber = 'barcodelabelNumber';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let status = 'status';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedReturnsRows.length > 0){
      for (var fieldReturnsVal in selectedReturnsRows) {
        var fieldReturnsObj = selectedReturnsRows[fieldReturnsVal];
        if(fieldReturnsObj.action){
            var returnsObj = (
              returnsObj={}, 
              returnsObj[reference_number]= fieldReturnsObj.reference_number != undefined ? fieldReturnsObj.reference_number : '', returnsObj,
              returnsObj[barcodelabelNumber]= fieldReturnsObj.barcodelabelNumber != undefined ? fieldReturnsObj.barcodelabelNumber : '', returnsObj,
              returnsObj[articleID]= fieldReturnsObj.articleID != undefined ? fieldReturnsObj.articleID : '', returnsObj,
              returnsObj[airwayBill]= fieldReturnsObj.airwayBill != undefined ? fieldReturnsObj.airwayBill : '', returnsObj,
              returnsObj[user_id]= fieldReturnsObj.user_id != undefined ? fieldReturnsObj.user_id : '', returnsObj,
              returnsObj[broker_Name]= fieldReturnsObj.broker_Name != undefined ? fieldReturnsObj.broker_Name : '', returnsObj,
              returnsObj[service_type]= fieldReturnsObj.service_type != undefined ? fieldReturnsObj.service_type : '', returnsObj,
              returnsObj[carrier]= fieldReturnsObj.carrier != undefined ? fieldReturnsObj.carrier : '', returnsObj,
              returnsObj[status]= fieldReturnsObj.status != undefined ? fieldReturnsObj.status : '', returnsObj,
              returnsObj[action]= fieldReturnsObj.action != undefined ? fieldReturnsObj.action : '', returnsObj,
              returnsObj[created_Timestamp]= fieldReturnsObj.created_Timestamp != undefined ? fieldReturnsObj.created_Timestamp : '', returnsObj,
              returnsObj[handling]= fieldReturnsObj.handling != undefined ? fieldReturnsObj.handling : '', returnsObj,
              returnsObj[statusUpdateFlag]= returnsObj.action ? true: false, returnsObj,
              returnsObj[handlingUpdateFlag]= returnsObj.handling ? true: false, returnsObj,
              returnsObj[commentsUpdateFlag]= false, returnsObj
            );
            this.customeReturnsList.push(returnsObj);
            console.log( this.customeReturnsList);
          }else if(fieldReturnsObj.handlingVal){
            var returnsObj = (
              returnsObj={}, 
              returnsObj[reference_number]= fieldReturnsObj.reference_number != undefined ? fieldReturnsObj.reference_number : '', returnsObj,
              returnsObj[barcodelabelNumber]= fieldReturnsObj.barcodelabelNumber != undefined ? fieldReturnsObj.barcodelabelNumber : '', returnsObj,
              returnsObj[articleID]= fieldReturnsObj.articleID != undefined ? fieldReturnsObj.articleID : '', returnsObj,
              returnsObj[airwayBill]= fieldReturnsObj.airwayBill != undefined ? fieldReturnsObj.airwayBill : '', returnsObj,
              returnsObj[user_id]= fieldReturnsObj.user_id != undefined ? fieldReturnsObj.user_id : '', returnsObj,
              returnsObj[broker_Name]= fieldReturnsObj.broker_Name != undefined ? fieldReturnsObj.broker_Name : '', returnsObj,
              returnsObj[service_type]= fieldReturnsObj.service_type != undefined ? fieldReturnsObj.service_type : '', returnsObj,
              returnsObj[carrier]= fieldReturnsObj.carrier != undefined ? fieldReturnsObj.carrier : '', returnsObj,
              returnsObj[status]= fieldReturnsObj.status != undefined ? fieldReturnsObj.status : '', returnsObj,
              returnsObj[action]= fieldReturnsObj.status != undefined ? fieldReturnsObj.status : '', returnsObj,
              returnsObj[created_Timestamp]= fieldReturnsObj.created_Timestamp != undefined ? fieldReturnsObj.created_Timestamp : '', returnsObj,
              returnsObj[handling]= fieldReturnsObj.handling != undefined ? fieldReturnsObj.handling : '', returnsObj,
              returnsObj[statusUpdateFlag]= returnsObj.action ? true: false, returnsObj,
              returnsObj[handlingUpdateFlag]= returnsObj.handling ? true: false, returnsObj,
              returnsObj[commentsUpdateFlag]= false, returnsObj
            );
            this.customeReturnsList.push(returnsObj);
            console.log( this.customeReturnsList);
          }else{
            this.errorMsg = "**Please change the Status to proceed further";
          }
        };

        if(this.customeReturnsList.length > 0){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.customeReturnsList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = 'Returning';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array);  
              $('#csModal').modal('show');
            })
        };
      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      } 
  };


  updateReturnedStatus(){
    console.log("Clicked on Returned");
    var selectedReturnedRows = this.gridOptionsReturned.api.getSelectedRows();
    this.customeReturnedList = [];
    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let barcodelabelNumber = 'barcodelabelNumber';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let status = 'status';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedReturnedRows.length > 0){
      for (var fieldReturnedVal in selectedReturnedRows) {
        var fieldReturnedObj = selectedReturnedRows[fieldReturnedVal];
        if(fieldReturnedObj.action){
            var returnedObj = (
              returnedObj={}, 
              returnedObj[reference_number]= fieldReturnedObj.reference_number != undefined ? fieldReturnedObj.reference_number : '', returnedObj,
              returnedObj[barcodelabelNumber]= fieldReturnedObj.barcodelabelNumber != undefined ? fieldReturnedObj.barcodelabelNumber : '', returnedObj,
              returnedObj[articleID]= fieldReturnedObj.articleID != undefined ? fieldReturnedObj.articleID : '', returnedObj,
              returnedObj[airwayBill]= fieldReturnedObj.airwayBill != undefined ? fieldReturnedObj.airwayBill : '', returnedObj,
              returnedObj[user_id]= fieldReturnedObj.user_id != undefined ? fieldReturnedObj.user_id : '', returnedObj,
              returnedObj[broker_Name]= fieldReturnedObj.broker_Name != undefined ? fieldReturnedObj.broker_Name : '', returnedObj,
              returnedObj[service_type]= fieldReturnedObj.service_type != undefined ? fieldReturnedObj.service_type : '', returnedObj,
              returnedObj[carrier]= fieldReturnedObj.carrier != undefined ? fieldReturnedObj.carrier : '', returnedObj,
              returnedObj[status]= fieldReturnedObj.status != undefined ? fieldReturnedObj.status : '', returnedObj,
              returnedObj[action]= fieldReturnedObj.action != undefined ? fieldReturnedObj.action : '', returnedObj,
              returnedObj[created_Timestamp]= fieldReturnedObj.created_Timestamp != undefined ? fieldReturnedObj.created_Timestamp : '', returnedObj,
              returnedObj[handling]= fieldReturnedObj.handling != undefined ? fieldReturnedObj.handling : '', returnedObj,
              returnedObj[statusUpdateFlag]= returnedObj.action ? true: false, returnedObj,
              returnedObj[handlingUpdateFlag]= returnedObj.handling ? true: false, returnedObj,
              returnedObj[commentsUpdateFlag]= false, returnedObj
            );
            this.customeReturnedList.push(returnedObj);
            console.log( this.customeReturnedList);
          }else if(fieldReturnedObj.handlingVal){
            var returnedObj = (
              returnedObj={}, 
              returnedObj[reference_number]= fieldReturnedObj.reference_number != undefined ? fieldReturnedObj.reference_number : '', returnedObj,
              returnedObj[barcodelabelNumber]= fieldReturnedObj.barcodelabelNumber != undefined ? fieldReturnedObj.barcodelabelNumber : '', returnedObj,
              returnedObj[articleID]= fieldReturnedObj.articleID != undefined ? fieldReturnedObj.articleID : '', returnedObj,
              returnedObj[airwayBill]= fieldReturnedObj.airwayBill != undefined ? fieldReturnedObj.airwayBill : '', returnedObj,
              returnedObj[user_id]= fieldReturnedObj.user_id != undefined ? fieldReturnedObj.user_id : '', returnedObj,
              returnedObj[broker_Name]= fieldReturnedObj.broker_Name != undefined ? fieldReturnedObj.broker_Name : '', returnedObj,
              returnedObj[service_type]= fieldReturnedObj.service_type != undefined ? fieldReturnedObj.service_type : '', returnedObj,
              returnedObj[carrier]= fieldReturnedObj.carrier != undefined ? fieldReturnedObj.carrier : '', returnedObj,
              returnedObj[status]= fieldReturnedObj.status != undefined ? fieldReturnedObj.status : '', returnedObj,
              returnedObj[action]= fieldReturnedObj.status != undefined ? fieldReturnedObj.status : '', returnedObj,
              returnedObj[created_Timestamp]= fieldReturnedObj.created_Timestamp != undefined ? fieldReturnedObj.created_Timestamp : '', returnedObj,
              returnedObj[handling]= fieldReturnedObj.handling != undefined ? fieldReturnedObj.handling : '', returnedObj,
              returnedObj[statusUpdateFlag]= returnedObj.action ? true: false, returnedObj,
              returnedObj[handlingUpdateFlag]= returnedObj.handling ? true: false, returnedObj,
              returnedObj[commentsUpdateFlag]= false, returnedObj
            );
            this.customeReturnedList.push(returnedObj);
            console.log( this.customeReturnedList);
          }else{
            this.errorMsg = "**Please change the Status to proceed further";
          }
        };

        if(this.customeReturnedList.length > 0){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.customeReturnedList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = 'Returned';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array);  
              $('#csModal').modal('show');
            })
        };
      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      } 
  };

  updateResentStatus(){
    console.log("Clicked on Resent");
    var selectedResentRows = this.gridOptionsResent.api.getSelectedRows();
    this.customeResentList = [];
    let action = 'action';
    let user_id = 'user_id';
    let reference_number = 'reference_number';
    let airwayBill = 'airwayBill';
    let articleID = 'articleID';
    let barcodelabelNumber = 'barcodelabelNumber';
    let carrier = 'carrier';
    let broker_Name = 'broker_Name'; 
    let status = 'status';
    let service_type = 'service_type';
    let created_Timestamp = 'created_Timestamp';
    let handling = 'handling';
    let statusUpdateFlag = 'statusUpdateFlag';
    let handlingUpdateFlag = 'handlingUpdateFlag';
    let commentsUpdateFlag = 'commentsUpdateFlag';

    if(selectedResentRows.length > 0){
      for (var fieldResentVal in selectedResentRows) {
        var fieldResentObj = selectedResentRows[fieldResentVal];
        if(fieldResentObj.action){
            var resentObj = (
              resentObj={}, 
              resentObj[reference_number]= fieldResentObj.reference_number != undefined ? fieldResentObj.reference_number : '', resentObj,
              resentObj[barcodelabelNumber]= fieldResentObj.barcodelabelNumber != undefined ? fieldResentObj.barcodelabelNumber : '', resentObj,
              resentObj[articleID]= fieldResentObj.articleID != undefined ? fieldResentObj.articleID : '', resentObj,
              resentObj[airwayBill]= fieldResentObj.airwayBill != undefined ? fieldResentObj.airwayBill : '', resentObj,
              resentObj[user_id]= fieldResentObj.user_id != undefined ? fieldResentObj.user_id : '', resentObj,
              resentObj[broker_Name]= fieldResentObj.broker_Name != undefined ? fieldResentObj.broker_Name : '', resentObj,
              resentObj[service_type]= fieldResentObj.service_type != undefined ? fieldResentObj.service_type : '', resentObj,
              resentObj[carrier]= fieldResentObj.carrier != undefined ? fieldResentObj.carrier : '', resentObj,
              resentObj[status]= fieldResentObj.status != undefined ? fieldResentObj.status : '', resentObj,
              resentObj[action]= fieldResentObj.action != undefined ? fieldResentObj.action : '', resentObj,
              resentObj[created_Timestamp]= fieldResentObj.created_Timestamp != undefined ? fieldResentObj.created_Timestamp : '', resentObj,
              resentObj[handling]= fieldResentObj.handling != undefined ? fieldResentObj.handling : '', resentObj,
              resentObj[statusUpdateFlag]= resentObj.action ? true: false, resentObj,
              resentObj[handlingUpdateFlag]= resentObj.handling ? true: false, resentObj,
              resentObj[commentsUpdateFlag]= false, resentObj
            );
            this.customeResentList.push(resentObj);
            console.log( this.customeResentList);
          }else if(fieldResentObj.handlingVal){
            var resentObj = (
              resentObj={}, 
              resentObj[reference_number]= fieldResentObj.reference_number != undefined ? fieldResentObj.reference_number : '', resentObj,
              resentObj[barcodelabelNumber]= fieldResentObj.barcodelabelNumber != undefined ? fieldResentObj.barcodelabelNumber : '', resentObj,
              resentObj[articleID]= fieldResentObj.articleID != undefined ? fieldResentObj.articleID : '', resentObj,
              resentObj[airwayBill]= fieldResentObj.airwayBill != undefined ? fieldResentObj.airwayBill : '', resentObj,
              resentObj[user_id]= fieldResentObj.user_id != undefined ? fieldResentObj.user_id : '', resentObj,
              resentObj[broker_Name]= fieldResentObj.broker_Name != undefined ? fieldResentObj.broker_Name : '', resentObj,
              resentObj[service_type]= fieldResentObj.service_type != undefined ? fieldResentObj.service_type : '', resentObj,
              resentObj[carrier]= fieldResentObj.carrier != undefined ? fieldResentObj.carrier : '', resentObj,
              resentObj[status]= fieldResentObj.status != undefined ? fieldResentObj.status : '', resentObj,
              resentObj[action]= fieldResentObj.status != undefined ? fieldResentObj.status : '', resentObj,
              resentObj[created_Timestamp]= fieldResentObj.created_Timestamp != undefined ? fieldResentObj.created_Timestamp : '', resentObj,
              resentObj[handling]= fieldResentObj.handling != undefined ? fieldResentObj.handling : '', resentObj,
              resentObj[statusUpdateFlag]= resentObj.action ? true: false, resentObj,
              resentObj[handlingUpdateFlag]= resentObj.handling ? true: false, resentObj,
              resentObj[commentsUpdateFlag]= false, resentObj
            );
            this.customeResentList.push(resentObj);
            console.log( this.customeResentList);
          }else{
            this.errorMsg = "**Please change the Status to proceed further";
          }
        };

        if(this.customeResentList.length > 0){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.customeResentList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = 'Resent';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array);  
              $('#csModal').modal('show');
            })
        };
      

      }else{
          this.errorMsg = "**Please select the below records to proceed further";
      }
  };

  csReports(){
    console.log("Report tab clicked")
  };

  onSelectionChange() {
    var selectedRows = this.gridOptionsMaster.api.getSelectedRows();
    console.log(selectedRows.length);
    this.bulkUpload = false;
    this.errorMsg = null;
  };

  onSelectionChangeReceived(){
    var selectedRowsReceived = this.gridOptionsReceived.api.getSelectedRows();
    this.errorMsg = null;
  };

  onSelectionChangeAllocated(){
    var selectedRowsAllocated = this.gridOptionsLIT.api.getSelectedRows();
    this.errorMsg = null;
  };

  onSelectionChangeTransit(){
    var selectedRowsTransit = this.gridOptionsTransit.api.getSelectedRows();
    this.errorMsg = null;
  };

  onSelectionChangeProactive(){
    var selectedRowsProactive = this.gridOptionsProactive.api.getSelectedRows();
    this.errorMsg = null;
  };

  onSelectionChangeInquiry(){
    var selectedRowsInquiry = this.gridOptionsInquiry.api.getSelectedRows();
    this.errorMsg = null;
  };

  onSelectionDelivered(){
    var selectedRowsDelivered = this.gridOptionsDelivered.api.getSelectedRows();
    this.errorMsg = null;
  };

  onSelectionReturns(){
    var selectedRowsReturns = this.gridOptionsReturns.api.getSelectedRows();
    console.log(this.gridOptionsReturns.api.getSelectedRows())
    this.errorMsg = null;
  };

  onSelectionReturned(){
    var selectedRowsReturned = this.gridOptionsReturned.api.getSelectedRows();
    this.errorMsg = null;
  };

  onSelectionResent(){
    var selectedRowsResent = this.gridOptionsResent.api.getSelectedRows();
    this.errorMsg = null;
  };

  fileDownload(rows, fileNameValue, ){
    console.log(rows);
    var currentTime = new Date();
    var csMasterList = [];
    var fileName = '';
        fileName = fileNameValue+"-"+currentTime.toLocaleDateString();
        var options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true, 
          useBom: true,
          headers: [ "Reference Number", "Article ID", "Date Allocated", "Broker Name", "Carrier", "Actual Status", "Mapped Status Timestamp", 
            "Mapped Status", "Actual Status Timestamp", "Handling", "Suburb", "Mapped Status",
            "Receiver Name", "Receiver Address", "Phone Number", "State", "Postcode", "Comments"]
        };

      let reference_number = 'reference_number';
      let articleID = 'articleID';
      let dateAllocated = 'dateAllocated';
      let broker_Name = 'broker_Name';
      let carrier = 'carrier';
      let status = 'status';
      let StatusDate = 'StatusDate';
      let systemStatus = 'systemStatus';
      let status_Timestamp = 'status_Timestamp';
      let handling = 'handling';
      let suburb = 'suburb';
      let receiverName = 'receiverName';
      let receiverAddress = 'receiverAddress';
      let phoneNumber = 'phoneNumber';
      let state = 'state';
      let postcode = 'postcode';
      let comments = 'comments';
  
      for (var importVal in rows) {
          var csObj = rows[importVal];
          var csMasterObj = (
            csMasterObj={}, 
            csMasterObj[reference_number]= csObj.reference_number != null ? csObj.reference_number: '', csMasterObj,
            csMasterObj[articleID]= csObj.articleID != null ? csObj.articleID : '', csMasterObj,
            csMasterObj[dateAllocated]= csObj.dateAllocated != null ? csObj.dateAllocated : '', csMasterObj,
            csMasterObj[broker_Name] = csObj.broker_Name != null ? csObj.broker_Name : '', csMasterObj,
            csMasterObj[carrier]= csObj.carrier != null ? csObj.carrier : '', csMasterObj,
            csMasterObj[status]= csObj.status != null ? csObj.status : '', csMasterObj,
            csMasterObj[StatusDate] = csObj.status_Timestamp != null ? csObj.status_Timestamp : '', csMasterObj,
            csMasterObj[systemStatus] = csObj.mappedStatus != null ? csObj.mappedStatus : '', csMasterObj,
             csMasterObj[status_Timestamp] = csObj.status_Timestamp != null ? csObj.status_Timestamp : '', csMasterObj,
            csMasterObj[handling]= csObj.handling != null ? csObj.handling : '', csMasterObj,
            csMasterObj[suburb]= csObj.suburb != null ? csObj.suburb : '', csMasterObj,
            csMasterObj[receiverName]= csObj.receiverName != null ? csObj.receiverName : '', csMasterObj,
            csMasterObj[receiverAddress]= csObj.receiverAddress != null ? csObj.receiverAddress : '', csMasterObj,
            csMasterObj[phoneNumber]= csObj.phoneNumber != null ? csObj.phoneNumber : '', csMasterObj,
            csMasterObj[state]= csObj.state != null ? csObj.state : '', csMasterObj,
            csMasterObj[postcode]= csObj.postcode != null ? csObj.postcode : '', csMasterObj,
            csMasterObj[comments]= csObj.comments != null ? csObj.comments : '', csMasterObj
          );
          csMasterList.push(csMasterObj)
      }
    new Angular2Csv(csMasterList, fileName, options);  
  };

  updateComments(){
    console.log(this.csSystemSelectedVal);
    this.moveValidViewFlag = false;
    let actionValue = '';
    if(this.actionVal){
        this.moveValidViewFlag = true;
        // if(this.csSystemSelectedVal.status === "Allocated by D2Z" && (this.actionVal === "ProActive CS" || this.actionVal === "Inquiry" ) ){
        //     this.moveValidViewFlag = true;
        // }else if(this.csSystemSelectedVal.status === "In Transit" && (this.actionVal === "ProActive CS" || this.actionVal === "Inquiry" || this.actionVal === "Inquiry" ) ){
        //     this.moveValidViewFlag = true;
        // }else if(this.csSystemSelectedVal.status === "ProActive CS" && (this.actionVal === "Delivered" || this.actionVal === "Inquiry" || this.actionVal === "Returns" ) ){
        //     this.moveValidViewFlag = true;
        // }else if(this.csSystemSelectedVal.status === "Inquiry" && (this.actionVal === "Delivered" || this.actionVal === "Returns" ) ){
        //     this.moveValidViewFlag = true;
        // }else if(this.csSystemSelectedVal.status === "Delivered" && (this.actionVal === "ProActive CS" || this.actionVal === "Inquiry" || this.actionVal === "Returns" ) ){
        //     this.moveValidViewFlag = true;
        // }else{  
        //     this.moveValidViewFlag = false;
        //     if( (this.csSystemSelectedVal.status === "Allocated by D2Z" || this.actionVal === "In Transit" )  && !(this.actionVal === "ProActive CS" || this.actionVal === "Inquiry" ) ){
        //         this.errorMsg = "Proactive CS or Inquiry Movement Alone is Allowed";
        //     }else if( (this.csSystemSelectedVal.status === "ProActive CS") && !(this.actionVal === "Delivered" || this.actionVal === "Inquiry" ||  this.actionVal === "Returns" ) ){
        //         this.errorMsg = " Inquiry or Delivered or Returns & Issues Movement Alone is Allowed";
        //     }else if( (this.csSystemSelectedVal.status === "Inquiry") && !(this.actionVal === "Delivered" || this.actionVal === "Returns" ) ){
        //         this.errorMsg = " Delivered or Returns & Issues Movement Alone is Allowed";
        //     }  
        // }
    };
    // console.log(this.moveValidViewFlag ? this.actionVal : this.csSystemSelectedVal.systemStatus);
    this.customerTrackerMessageList = [];
    let commentsVal = document.getElementById("comments")["value"].trim();
    console.log("commentsVal -->"+commentsVal);
    var reference_number_val = this.csSystemSelectedVal.reference_number;
      let action = 'action';
      let user_id = 'user_id';
      let reference_number = 'reference_number';
      let airwayBill = 'airwayBill';
      let articleID = 'articleID';
      let barcodelabelNumber = 'barcodelabelNumber';
      let carrier = 'carrier';
      let broker_Name = 'broker_Name'; 
      let systemStatus = 'systemStatus';
      let service_type = 'service_type';
      let created_Timestamp = 'created_Timestamp';
      let handling = 'handling';
      let comments = 'comments';
      let statusUpdateFlag = 'statusUpdateFlag';
      let handlingUpdateFlag = 'handlingUpdateFlag';
      let commentsUpdateFlag = 'commentsUpdateFlag';

      var csMsgObj = (
        csMsgObj={}, 
        csMsgObj[reference_number]= this.csSystemSelectedVal.reference_number != undefined ? this.csSystemSelectedVal.reference_number : '', csMsgObj,
        csMsgObj[barcodelabelNumber]= this.csSystemSelectedVal.barcodelabelNumber != undefined ? this.csSystemSelectedVal.barcodelabelNumber : '', csMsgObj,
        csMsgObj[articleID]= this.csSystemSelectedVal.articleID != undefined ? this.csSystemSelectedVal.articleID : '', csMsgObj,
        csMsgObj[airwayBill]= this.csSystemSelectedVal.airwayBill != undefined ? this.csSystemSelectedVal.airwayBill : '', csMsgObj,
        csMsgObj[user_id]= this.csSystemSelectedVal.user_Id != undefined ? this.csSystemSelectedVal.user_Id : '', csMsgObj,
        csMsgObj[broker_Name]= this.csSystemSelectedVal.broker_Name != undefined ? this.csSystemSelectedVal.broker_Name : '', csMsgObj,
        csMsgObj[service_type]= this.csSystemSelectedVal.service_type != undefined ? this.csSystemSelectedVal.service_type : '', csMsgObj,
        csMsgObj[carrier]= this.csSystemSelectedVal.carrier != undefined ? this.csSystemSelectedVal.carrier : '', csMsgObj,
        csMsgObj[systemStatus]= this.csSystemSelectedVal.systemStatus != undefined ? this.csSystemSelectedVal.systemStatus : '', csMsgObj,
        csMsgObj[action]= this.moveValidViewFlag ? this.actionVal : this.csSystemSelectedVal.systemStatus, csMsgObj,
        csMsgObj[created_Timestamp]= this.csSystemSelectedVal.created_Timestamp != undefined ? this.csSystemSelectedVal.created_Timestamp : '', csMsgObj,
        // csMsgObj[handling]= this.handlingVal != undefined ? this.handlingVal : this.csSystemSelectedVal.handling, csMsgObj,
        csMsgObj[handling]= this.userMessage.userName != undefined ? this.userMessage.userName : '', csMsgObj,
        csMsgObj[comments]= commentsVal != undefined ? commentsVal : null, csMsgObj,
        csMsgObj[statusUpdateFlag]= this.moveValidViewFlag ? true: false, csMsgObj,
        csMsgObj[handlingUpdateFlag]=this.handlingVal ? true: false, csMsgObj,
        csMsgObj[commentsUpdateFlag]= commentsVal ? true: false, csMsgObj
      );
      this.customerTrackerMessageList.push(csMsgObj);
      console.log( this.customerTrackerMessageList);

      if(this.customerTrackerMessageList.length > 0){
        this.spinner.show();
          this.consigmentUploadService.updateCSstatus(this.customerTrackerMessageList, (resp) => {
            this.spinner.hide();
            if(resp.error){
              this.successMsg = resp.error.errorMessage;
            }else{
              this.successMsg = resp.message;
              this.errorMsg = '';
            }
            this.csTrackerApi(this.CSstatus, this.reference_number_array);
            this.CSstatus = '';
            this.reference_number_array = '';
            this.csTrackerApi(this.CSstatus, this.reference_number_array); 
            this.consigmentUploadService.csDetailsHist(reference_number_val, (resp) => {
              this.spinner.hide();
              this.rowDataMsg = resp;
              setTimeout(() => {this.spinner.hide()}, 5000);
            });
             
             $('#msgModal').modal('hide');
            document.getElementById("comments")["value"] = '';
            $('#csModal').modal('show');
            this.actionVal = '';
            this.handlingVal = '';
          })
      };
  };

  ViewPodFile(){
    console.log(this.csSystemSelectedVal.articleID);
    this.spinner.show();
      this.consigmentUploadService.viewPodFileStatus(this.csSystemSelectedVal.articleID, (resp) => {
        this.spinner.hide();
        if(resp.error){
          this.successMsg = resp.error.errorMessage;
        }else{
          this.successMsg = resp.message;
          this.errorMsg = '';
        }
      })
  };

  bulkUpdateStatus(){
      if(this.gridOptionsMaster.api.getSelectedRows().length > 1){
        console.log("Bulk Uploaded Clicked");
        $('#bulkModal').modal('show');
      }else{
        this.errorMsg = "Select more than one records to process Bulk request";
      }
  };

  bulkRequestUpdate(){
      var bulkRecords = this.gridOptionsMaster.api.getSelectedRows();
      console.log(bulkRecords);
      console.log(this.handlingVal);
      console.log(this.actionVal);
      let commentsBulkVal = document.getElementById("commentsBulk")["value"].trim();
      this.bulkUpdateList = [];
        let action = 'action';
        let reference_number = 'reference_number';
        let airwayBill = 'airwayBill';
        let articleID = 'articleID';
        let barcodelabelNumber = 'barcodelabelNumber';
        let user_id = 'user_id';
        let broker_Name = 'broker_Name'; 
        let carrier = 'carrier';
        let systemStatus = 'systemStatus';
        let service_type = 'service_type';
        let created_Timestamp = 'created_Timestamp';
        let handling = 'handling';
        let comments = 'comments';
        let statusUpdateFlag = 'statusUpdateFlag';
        let handlingUpdateFlag = 'handlingUpdateFlag';
        let commentsUpdateFlag = 'commentsUpdateFlag';

        if(this.actionVal){
          console.log(this.actionVal);
        }

        if(this.handlingVal || this.actionVal){
          this.bulkUpload = true;
        }else{
          this.bulkUpload = false;
          this.errorMsg = "To Proceed further request you to change the Status (OR) Handling Values";
        }

        if(bulkRecords.length > 0 && this.bulkUpload){
          this.errorMsg = '';
          for (var fieldBulkVal in bulkRecords) {
            var fieldBulkObj = bulkRecords[fieldBulkVal];
            var csBulkObj = (
                csBulkObj={}, 
                csBulkObj[reference_number]= fieldBulkObj.reference_number != undefined ? fieldBulkObj.reference_number : '', csBulkObj,
                csBulkObj[barcodelabelNumber]= fieldBulkObj.barcodelabelNumber != undefined ? fieldBulkObj.barcodelabelNumber : '', csBulkObj,
                csBulkObj[articleID]= fieldBulkObj.articleID != undefined ? fieldBulkObj.articleID : '', csBulkObj,
                csBulkObj[airwayBill]= fieldBulkObj.airwayBill != undefined ? fieldBulkObj.airwayBill : '', csBulkObj,
                csBulkObj[user_id]= fieldBulkObj.user_Id != undefined ? fieldBulkObj.user_Id : '', csBulkObj,
                csBulkObj[broker_Name]= fieldBulkObj.broker_Name != undefined ? fieldBulkObj.broker_Name : '', csBulkObj,
                csBulkObj[service_type]= fieldBulkObj.service_type != undefined ? fieldBulkObj.service_type : '', csBulkObj,
                csBulkObj[carrier]= fieldBulkObj.carrier != undefined ? fieldBulkObj.carrier : '', csBulkObj,
                csBulkObj[systemStatus]= fieldBulkObj.systemStatus != undefined ? fieldBulkObj.systemStatus : '', csBulkObj,
                csBulkObj[action]= this.actionVal ? this.actionVal : fieldBulkObj.systemStatus, csBulkObj,
                csBulkObj[created_Timestamp]= fieldBulkObj.created_Timestamp != undefined ? fieldBulkObj.created_Timestamp : '', csBulkObj,
                csBulkObj[handling]= this.handlingVal ? this.handlingVal : fieldBulkObj.handling, csBulkObj,
                csBulkObj[comments]= commentsBulkVal != undefined ? commentsBulkVal : fieldBulkObj.comments, csBulkObj,
                csBulkObj[statusUpdateFlag] = ( this.actionVal != fieldBulkObj.systemStatus) ? true : false, csBulkObj,
                csBulkObj[handlingUpdateFlag] = ( this.handlingVal != fieldBulkObj.handling ) ? true: false, csBulkObj,
                csBulkObj[commentsUpdateFlag] = false, csBulkObj
            );
            this.bulkUpdateList.push(csBulkObj);
          }
        }
        console.log(this.bulkUpdateList);
        if(bulkRecords.length > 0 && this.bulkUpload){
          this.spinner.show();
            this.consigmentUploadService.updateCSstatus(this.bulkUpdateList, (resp) => {
              this.spinner.hide();
              if(resp.error){
                this.successMsg = resp.error.errorMessage;
              }else{
                this.successMsg = resp.message;
                this.errorMsg = '';
              }
              this.CSstatus = '';
              this.reference_number_array = '';
              this.csTrackerApi(this.CSstatus, this.reference_number_array); 
              $('#bulkModal').modal('hide');
              $('#csModal').modal('show');
            })
        };
  };

  downloadMasterData(){
      console.log("Clicked On the Master Data Download")
      var selectedMasterRows = this.gridOptionsMaster.api.getSelectedRows();
      var selectedRows = this.gridOptionsMaster.api.getFilterModel()
      this.reference_number_val = "";
      this.barcode_label_val = "";
      this.articleID_val = "";
      this.airwayBill_val = "";
      this.broker_Name_val = "";
      this.carrier_val = "";
      this.status_val = "";
      this.suburb_val = "";
      this.receiverName_val = "";
      this.receiverAddress_val = "";
      this.phoneNumber_val = "";
      this.state_val = "";
      this.postcode_val = "";
      this.comments_val = "";
      this.dateAllocated_val = "";
      this.status_Timestamp_val = "";
      this.systemStatus_val = "";
      this.updated_Timestamp_val = "";

      var selectedMasterFilterRows = [];
      if(selectedRows.reference_number){
        this.reference_number_val = selectedRows.reference_number.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
      }else if (selectedRows.barcodelabelNumber){
        this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
      }else if(selectedRows.articleID){
        this.articleID_val = selectedRows.articleID.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
      }else if(selectedRows.dateAllocated){
        this.dateAllocated_val = selectedRows.dateAllocated.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
      }else if(selectedRows.broker_Name){
        this.broker_Name_val = selectedRows.broker_Name.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
      }else if(selectedRows.carrier){
        this.carrier_val = selectedRows.carrier.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
      }else if(selectedRows.status){
        this.status_val = selectedRows.status.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
      }else if(selectedRows.receiverName){
        this.receiverName_val = selectedRows.receiverName.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
      }else if(selectedRows.receiverAddress){
        this.receiverAddress_val = selectedRows.receiverAddress.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
      }else if(selectedRows.phoneNumber){
        this.phoneNumber_val = selectedRows.phoneNumber.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
      }else if(selectedRows.state){
        this.state_val = selectedRows.state.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
      }else if(selectedRows.postcode){
        this.postcode_val = selectedRows.postcode.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
      }else if(selectedRows.comments){
        this.comments_val = selectedRows.comments.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
      }else if(selectedRows.status_Timestamp){
        this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
      }else if(selectedRows.systemStatus){
        this.systemStatus_val = selectedRows.systemStatus.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
      }else if(selectedRows.updated_Timestamp){
        this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
        selectedMasterFilterRows = selectedMasterRows.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
      }else{
        selectedMasterFilterRows = selectedMasterRows;
      }

      if(selectedMasterFilterRows.length > 0 ){
          this.fileDownload(selectedMasterFilterRows, "Customer Service Master Data")
      }else{
          this.errorMsg = "**Please select the below records to download the Master Data details";
     }
  };

  downloadDataReceived(){
    var selectedRowsReceived = this.gridOptionsReceived.api.getSelectedRows();
    var selectedRows = this.gridOptionsReceived.api.getFilterModel()
      this.reference_number_val = "";
      this.barcode_label_val = "";
      this.articleID_val = "";
      this.airwayBill_val = "";
      this.broker_Name_val = "";
      this.carrier_val = "";
      this.status_val = "";
      this.suburb_val = "";
      this.receiverName_val = "";
      this.receiverAddress_val = "";
      this.phoneNumber_val = "";
      this.state_val = "";
      this.postcode_val = "";
      this.comments_val = "";
      this.dateAllocated_val = "";
      this.status_Timestamp_val = "";
      this.systemStatus_val = "";
      this.updated_Timestamp_val = "";

      var selectedDataReceivedFilterRows = [];
      if(selectedRows.reference_number){
        this.reference_number_val = selectedRows.reference_number.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
      }else if (selectedRows.barcodelabelNumber){
        this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
      }else if(selectedRows.articleID){
        this.articleID_val = selectedRows.articleID.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
      }else if(selectedRows.dateAllocated){
        this.dateAllocated_val = selectedRows.dateAllocated.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
      }else if(selectedRows.broker_Name){
        this.broker_Name_val = selectedRows.broker_Name.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
      }else if(selectedRows.carrier){
        this.carrier_val = selectedRows.carrier.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
      }else if(selectedRows.status){
        this.status_val = selectedRows.status.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
      }else if(selectedRows.receiverName){
        this.receiverName_val = selectedRows.receiverName.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
      }else if(selectedRows.receiverAddress){
        this.receiverAddress_val = selectedRows.receiverAddress.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
      }else if(selectedRows.phoneNumber){
        this.phoneNumber_val = selectedRows.phoneNumber.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
      }else if(selectedRows.state){
        this.state_val = selectedRows.state.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
      }else if(selectedRows.postcode){
        this.postcode_val = selectedRows.postcode.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
      }else if(selectedRows.comments){
        this.comments_val = selectedRows.comments.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
      }else if(selectedRows.status_Timestamp){
        this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
      }else if(selectedRows.systemStatus){
        this.systemStatus_val = selectedRows.systemStatus.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
      }else if(selectedRows.updated_Timestamp){
        this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
        selectedDataReceivedFilterRows = selectedRowsReceived.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
      }else{
        selectedDataReceivedFilterRows = selectedRowsReceived;
      }

      if(selectedDataReceivedFilterRows.length > 0 ){
          this.fileDownload(selectedDataReceivedFilterRows, "Customer Service Collected ")
    }else{
          this.errorMsg = "**Please select the below records to download the Collected Details";
    }
  };
  
  downloadDataLIT(){
    var selectedRowsAllocated = this.gridOptionsLIT.api.getSelectedRows();
    var selectedRows = this.gridOptionsLIT.api.getFilterModel()
      this.reference_number_val = "";
      this.barcode_label_val = "";
      this.articleID_val = "";
      this.airwayBill_val = "";
      this.broker_Name_val = "";
      this.carrier_val = "";
      this.status_val = "";
      this.suburb_val = "";
      this.receiverName_val = "";
      this.receiverAddress_val = "";
      this.phoneNumber_val = "";
      this.state_val = "";
      this.postcode_val = "";
      this.comments_val = "";
      this.dateAllocated_val = "";
      this.status_Timestamp_val = "";
      this.systemStatus_val = "";
      this.updated_Timestamp_val = "";

      var selectedAllocatedFilterRows = [];
      if(selectedRows.reference_number){
        this.reference_number_val = selectedRows.reference_number.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
      }else if (selectedRows.barcodelabelNumber){
        this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
      }else if(selectedRows.articleID){
        this.articleID_val = selectedRows.articleID.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
      }else if(selectedRows.dateAllocated){
        this.dateAllocated_val = selectedRows.dateAllocated.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
      }else if(selectedRows.broker_Name){
        this.broker_Name_val = selectedRows.broker_Name.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
      }else if(selectedRows.carrier){
        this.carrier_val = selectedRows.carrier.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
      }else if(selectedRows.status){
        this.status_val = selectedRows.status.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
      }else if(selectedRows.receiverName){
        this.receiverName_val = selectedRows.receiverName.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
      }else if(selectedRows.receiverAddress){
        this.receiverAddress_val = selectedRows.receiverAddress.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
      }else if(selectedRows.phoneNumber){
        this.phoneNumber_val = selectedRows.phoneNumber.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
      }else if(selectedRows.state){
        this.state_val = selectedRows.state.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
      }else if(selectedRows.postcode){
        this.postcode_val = selectedRows.postcode.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
      }else if(selectedRows.comments){
        this.comments_val = selectedRows.comments.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
      }else if(selectedRows.status_Timestamp){
        this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
      }else if(selectedRows.systemStatus){
        this.systemStatus_val = selectedRows.systemStatus.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
      }else if(selectedRows.updated_Timestamp){
        this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
        selectedAllocatedFilterRows = selectedRowsAllocated.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
      }else{
        selectedAllocatedFilterRows = selectedRowsAllocated;
      }

      if(selectedAllocatedFilterRows.length > 0 ){
          this.fileDownload(selectedAllocatedFilterRows, "Customer Service - LIT ")
    }else{
          this.errorMsg = "**Please select the below records to download the LIT Details";
    }
  };

  downloadDataInTransit(){
    var selectedRowsTransit = this.gridOptionsTransit.api.getSelectedRows();
    var selectedRows = this.gridOptionsTransit.api.getFilterModel()
      this.reference_number_val = "";
      this.barcode_label_val = "";
      this.articleID_val = "";
      this.airwayBill_val = "";
      this.broker_Name_val = "";
      this.carrier_val = "";
      this.status_val = "";
      this.suburb_val = "";
      this.receiverName_val = "";
      this.receiverAddress_val = "";
      this.phoneNumber_val = "";
      this.state_val = "";
      this.postcode_val = "";
      this.comments_val = "";
      this.dateAllocated_val = "";
      this.status_Timestamp_val = "";
      this.systemStatus_val = "";
      this.updated_Timestamp_val = "";

      var selectedInTransitFilterRows = [];
      if(selectedRows.reference_number){
        this.reference_number_val = selectedRows.reference_number.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
      }else if (selectedRows.barcodelabelNumber){
        this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
      }else if(selectedRows.articleID){
        this.articleID_val = selectedRows.articleID.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
      }else if(selectedRows.dateAllocated){
        this.dateAllocated_val = selectedRows.dateAllocated.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
      }else if(selectedRows.broker_Name){
        this.broker_Name_val = selectedRows.broker_Name.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
      }else if(selectedRows.carrier){
        this.carrier_val = selectedRows.carrier.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
      }else if(selectedRows.status){
        this.status_val = selectedRows.status.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
      }else if(selectedRows.receiverName){
        this.receiverName_val = selectedRows.receiverName.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
      }else if(selectedRows.receiverAddress){
        this.receiverAddress_val = selectedRows.receiverAddress.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
      }else if(selectedRows.phoneNumber){
        this.phoneNumber_val = selectedRows.phoneNumber.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
      }else if(selectedRows.state){
        this.state_val = selectedRows.state.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
      }else if(selectedRows.postcode){
        this.postcode_val = selectedRows.postcode.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
      }else if(selectedRows.comments){
        this.comments_val = selectedRows.comments.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
      }else if(selectedRows.status_Timestamp){
        this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
      }else if(selectedRows.systemStatus){
        this.systemStatus_val = selectedRows.systemStatus.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
      }else if(selectedRows.updated_Timestamp){
        this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
        selectedInTransitFilterRows = selectedRowsTransit.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
      }else{
        selectedInTransitFilterRows = selectedRowsTransit;
      }

      if(selectedInTransitFilterRows.length > 0 ){
          this.fileDownload(selectedInTransitFilterRows, "Customer Service - In Transit Data ")
      }else{
          this.errorMsg = "**Please select the below records to download the In Transit Data Details";
    }
  };

  downloadDataProactiveCS(){
    var selectedRowsProactive = this.gridOptionsProactive.api.getSelectedRows();
    console.log(selectedRowsProactive)
    var selectedRows = this.gridOptionsProactive.api.getFilterModel()
    this.reference_number_val = "";
    this.barcode_label_val = "";
    this.articleID_val = "";
    this.airwayBill_val = "";
    this.broker_Name_val = "";
    this.carrier_val = "";
    this.status_val = "";
    this.suburb_val = "";
    this.receiverName_val = "";
    this.receiverAddress_val = "";
    this.phoneNumber_val = "";
    this.state_val = "";
    this.postcode_val = "";
    this.comments_val = "";
    this.dateAllocated_val = "";
    this.status_Timestamp_val = "";
    this.systemStatus_val = "";
    this.updated_Timestamp_val = "";

    var selectedProActiveFilterRows = [];
    if(selectedRows.reference_number){
      this.reference_number_val = selectedRows.reference_number.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
    }else if (selectedRows.barcodelabelNumber){
      this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
    }else if(selectedRows.articleID){
      this.articleID_val = selectedRows.articleID.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
    }else if(selectedRows.dateAllocated){
      this.dateAllocated_val = selectedRows.dateAllocated.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
    }else if(selectedRows.broker_Name){
      this.broker_Name_val = selectedRows.broker_Name.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
    }else if(selectedRows.carrier){
      this.carrier_val = selectedRows.carrier.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
    }else if(selectedRows.status){
      this.status_val = selectedRows.status.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
    }else if(selectedRows.suburb){
      this.suburb_val = selectedRows.suburb.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.suburb.toUpperCase() === this.suburb_val.toUpperCase() )
    } else if(selectedRows.receiverName){
      this.receiverName_val = selectedRows.receiverName.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
    }else if(selectedRows.receiverAddress){
      this.receiverAddress_val = selectedRows.receiverAddress.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
    }else if(selectedRows.phoneNumber){
      this.phoneNumber_val = selectedRows.phoneNumber.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
    }else if(selectedRows.state){
      this.state_val = selectedRows.state.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
    }else if(selectedRows.postcode){
      this.postcode_val = selectedRows.postcode.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
    }else if(selectedRows.comments){
      this.comments_val = selectedRows.comments.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
    }else if(selectedRows.status_Timestamp){
      this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
    }else if(selectedRows.systemStatus){
      this.systemStatus_val = selectedRows.systemStatus.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
    }else if(selectedRows.updated_Timestamp){
      this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
      selectedProActiveFilterRows = selectedRowsProactive.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
    }else{
      selectedProActiveFilterRows = selectedRowsProactive;
    }

    if(selectedProActiveFilterRows.length > 0 ){
          this.fileDownload(selectedProActiveFilterRows, "Customer Service - ProActive Data ")
    }else{
          this.errorMsg = "**Please select the below records to download the ProActive Data Details";
    }
  };

  downloadDataInquiry(){
    var selectedRowsInquiry = this.gridOptionsInquiry.api.getSelectedRows();
    var selectedRows = this.gridOptionsInquiry.api.getFilterModel()
    this.reference_number_val = "";
    this.barcode_label_val = "";
    this.articleID_val = "";
    this.airwayBill_val = "";
    this.broker_Name_val = "";
    this.carrier_val = "";
    this.status_val = "";
    this.suburb_val = "";
    this.receiverName_val = "";
    this.receiverAddress_val = "";
    this.phoneNumber_val = "";
    this.state_val = "";
    this.postcode_val = "";
    this.comments_val = "";
    this.dateAllocated_val = "";
    this.status_Timestamp_val = "";
    this.systemStatus_val = "";
    this.updated_Timestamp_val = "";

    var selectedInquiryFilterRows = [];
    if(selectedRows.reference_number){
      this.reference_number_val = selectedRows.reference_number.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
    }else if (selectedRows.barcodelabelNumber){
      this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
    }else if(selectedRows.articleID){
      this.articleID_val = selectedRows.articleID.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
    }else if(selectedRows.dateAllocated){
      this.dateAllocated_val = selectedRows.dateAllocated.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
    }else if(selectedRows.broker_Name){
      this.broker_Name_val = selectedRows.broker_Name.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
    }else if(selectedRows.carrier){
      this.carrier_val = selectedRows.carrier.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
    }else if(selectedRows.status){
      this.status_val = selectedRows.status.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
    }else if(selectedRows.suburb){
      this.suburb_val = selectedRows.suburb.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.suburb.toUpperCase() === this.suburb_val.toUpperCase() )
    }else if(selectedRows.receiverName){
      this.receiverName_val = selectedRows.receiverName.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
    }else if(selectedRows.receiverAddress){
      this.receiverAddress_val = selectedRows.receiverAddress.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
    }else if(selectedRows.phoneNumber){
      this.phoneNumber_val = selectedRows.phoneNumber.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
    }else if(selectedRows.state){
      this.state_val = selectedRows.state.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
    }else if(selectedRows.postcode){
      this.postcode_val = selectedRows.postcode.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
    }else if(selectedRows.comments){
      this.comments_val = selectedRows.comments.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
    }else if(selectedRows.status_Timestamp){
      this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
    }else if(selectedRows.systemStatus){
      this.systemStatus_val = selectedRows.systemStatus.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
    }else if(selectedRows.updated_Timestamp){
      this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
      selectedInquiryFilterRows = selectedRowsInquiry.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
    }
    else{
      selectedInquiryFilterRows = selectedRowsInquiry;
    }

    if(selectedInquiryFilterRows.length > 0 ){
          this.fileDownload(selectedInquiryFilterRows, "Customer Service - Inquiry Data ")
    }else{
          this.errorMsg = "**Please select the below records to download the Inquiry Data Details";
    }
  };

  downloadDelivered(){
    var selectedRowsDelivered = this.gridOptionsDelivered.api.getSelectedRows();
    var selectedRows = this.gridOptionsDelivered.api.getFilterModel()
    this.reference_number_val = "";
    this.barcode_label_val = "";
    this.articleID_val = "";
    this.airwayBill_val = "";
    this.broker_Name_val = "";
    this.carrier_val = "";
    this.status_val = "";
    this.receiverName_val = "";
    this.receiverAddress_val = "";
    this.phoneNumber_val = "";
    this.state_val = "";
    this.postcode_val = "";
    this.comments_val = "";
    this.dateAllocated_val = "";
    this.status_Timestamp_val = "";
    this.systemStatus_val = "";
    this.updated_Timestamp_val = "";

    var selectedDeliverFilterRows = [];
    if(selectedRows.reference_number){
      this.reference_number_val = selectedRows.reference_number.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
    }else if (selectedRows.barcodelabelNumber){
      this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
    }else if(selectedRows.articleID){
      this.articleID_val = selectedRows.articleID.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
    }else if(selectedRows.dateAllocated){
      this.dateAllocated_val = selectedRows.dateAllocated.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
    }else if(selectedRows.broker_Name){
      this.broker_Name_val = selectedRows.broker_Name.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
    }else if(selectedRows.carrier){
      this.carrier_val = selectedRows.carrier.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
    }else if(selectedRows.status){
      this.status_val = selectedRows.status.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
    }else if(selectedRows.receiverName){
      this.receiverName_val = selectedRows.receiverName.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
    }else if(selectedRows.receiverAddress){
      this.receiverAddress_val = selectedRows.receiverAddress.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
    }else if(selectedRows.phoneNumber){
      this.phoneNumber_val = selectedRows.phoneNumber.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
    }else if(selectedRows.state){
      this.state_val = selectedRows.state.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
    }else if(selectedRows.postcode){
      this.postcode_val = selectedRows.postcode.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
    }else if(selectedRows.comments){
      this.comments_val = selectedRows.comments.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
    }else if(selectedRows.status_Timestamp){
      this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
    }else if(selectedRows.systemStatus){
      this.systemStatus_val = selectedRows.systemStatus.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
    }else if(selectedRows.updated_Timestamp){
      this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
      selectedDeliverFilterRows = selectedRowsDelivered.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
    }else{
      selectedDeliverFilterRows = selectedRowsDelivered;
    }

    if(selectedDeliverFilterRows.length > 0 ){
          this.fileDownload(selectedDeliverFilterRows, "Customer Service - Delivered Data ")
    }else{
          this.errorMsg = "**Please select the below records to download the Delivered Data Details";
    }
  };

  downloadDataReturns(){
    var selectedRowsReturns = this.gridOptionsReturns.api.getSelectedRows();
    var selectedRows = this.gridOptionsReturns.api.getFilterModel()
    this.reference_number_val = "";
    this.barcode_label_val = "";
    this.articleID_val = "";
    this.airwayBill_val = "";
    this.broker_Name_val = "";
    this.carrier_val = "";
    this.status_val = "";
    this.receiverName_val = "";
    this.receiverAddress_val = "";
    this.phoneNumber_val = "";
    this.state_val = "";
    this.postcode_val = "";
    this.comments_val = "";
    this.dateAllocated_val = "";
    this.status_Timestamp_val = "";
    this.systemStatus_val = "";
    this.updated_Timestamp_val = "";

    var selectedReturnsFilterRows = [];
    if(selectedRows.reference_number){
      this.reference_number_val = selectedRows.reference_number.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
    }else if (selectedRows.barcodelabelNumber){
      this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
    }else if(selectedRows.articleID){
      this.articleID_val = selectedRows.articleID.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
    }else if(selectedRows.dateAllocated){
      this.dateAllocated_val = selectedRows.dateAllocated.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
    }else if(selectedRows.broker_Name){
      this.broker_Name_val = selectedRows.broker_Name.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
    }else if(selectedRows.carrier){
      this.carrier_val = selectedRows.carrier.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
    }else if(selectedRows.status){
      this.status_val = selectedRows.status.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
    }else if(selectedRows.receiverName){
      this.receiverName_val = selectedRows.receiverName.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
    }else if(selectedRows.receiverAddress){
      this.receiverAddress_val = selectedRows.receiverAddress.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
    }else if(selectedRows.phoneNumber){
      this.phoneNumber_val = selectedRows.phoneNumber.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
    }else if(selectedRows.state){
      this.state_val = selectedRows.state.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
    }else if(selectedRows.postcode){
      this.postcode_val = selectedRows.postcode.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
    }else if(selectedRows.comments){
      this.comments_val = selectedRows.comments.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
    }else if(selectedRows.status_Timestamp){
      this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
    }else if(selectedRows.systemStatus){
      this.systemStatus_val = selectedRows.systemStatus.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
    }else if(selectedRows.updated_Timestamp){
      this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
      selectedReturnsFilterRows = selectedRowsReturns.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
    }else{
      selectedReturnsFilterRows = selectedRowsReturns;
    }

    if(selectedReturnsFilterRows.length > 0 ){
          this.fileDownload(selectedReturnsFilterRows, "Customer Service - Delivery Issues ")
    }else{
          this.errorMsg = "**Please select the below records to download the Delivery Issues Details";
    }
  };

  downloadDataReturned(){
    var selectedRowsReturned = this.gridOptionsReturned.api.getSelectedRows();
    var selectedRows = this.gridOptionsReturned.api.getFilterModel()
    this.reference_number_val = "";
    this.barcode_label_val = "";
    this.articleID_val = "";
    this.airwayBill_val = "";
    this.broker_Name_val = "";
    this.carrier_val = "";
    this.status_val = "";
    this.receiverName_val = "";
    this.receiverAddress_val = "";
    this.phoneNumber_val = "";
    this.state_val = "";
    this.postcode_val = "";
    this.comments_val = "";
    this.dateAllocated_val = "";
    this.status_Timestamp_val = "";
    this.systemStatus_val = "";
    this.updated_Timestamp_val = "";

    var selectedReturnedFilterRows = [];
    if(selectedRows.reference_number){
      this.reference_number_val = selectedRows.reference_number.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
    }else if (selectedRows.barcodelabelNumber){
      this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
    }else if(selectedRows.articleID){
      this.articleID_val = selectedRows.articleID.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
    }else if(selectedRows.dateAllocated){
      this.dateAllocated_val = selectedRows.dateAllocated.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
    }else if(selectedRows.broker_Name){
      this.broker_Name_val = selectedRows.broker_Name.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
    }else if(selectedRows.carrier){
      this.carrier_val = selectedRows.carrier.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
    }else if(selectedRows.status){
      this.status_val = selectedRows.status.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
    }else if(selectedRows.receiverName){
      this.receiverName_val = selectedRows.receiverName.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
    }else if(selectedRows.receiverAddress){
      this.receiverAddress_val = selectedRows.receiverAddress.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
    }else if(selectedRows.phoneNumber){
      this.phoneNumber_val = selectedRows.phoneNumber.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
    }else if(selectedRows.state){
      this.state_val = selectedRows.state.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
    }else if(selectedRows.postcode){
      this.postcode_val = selectedRows.postcode.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
    }else if(selectedRows.comments){
      this.comments_val = selectedRows.comments.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
    }else if(selectedRows.status_Timestamp){
      this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
    }else if(selectedRows.systemStatus){
      this.systemStatus_val = selectedRows.systemStatus.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
    }else if(selectedRows.updated_Timestamp){
      this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
      selectedReturnedFilterRows = selectedRowsReturned.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
    }else{
      selectedReturnedFilterRows = selectedRowsReturned;
    }

    if(selectedReturnedFilterRows.length > 0 ){
          this.fileDownload(selectedReturnedFilterRows, "Customer Service - Returned Data ")
    }else{
          this.errorMsg = "**Please select the below records to download the Returned Data Details";
    }
  };

  downloadDataResent(){
    var selectedRowsResent = this.gridOptionsResent.api.getSelectedRows();
    var selectedRows = this.gridOptionsResent.api.getFilterModel()
    this.reference_number_val = "";
    this.barcode_label_val = "";
    this.articleID_val = "";
    this.airwayBill_val = "";
    this.broker_Name_val = "";
    this.carrier_val = "";
    this.status_val = "";
    this.receiverName_val = "";
    this.receiverAddress_val = "";
    this.phoneNumber_val = "";
    this.state_val = "";
    this.postcode_val = "";
    this.comments_val = "";
    this.dateAllocated_val = "";
    this.status_Timestamp_val = "";
    this.systemStatus_val = "";
    this.updated_Timestamp_val = "";

    var selectedResentFilterRows = [];
    if(selectedRows.reference_number){
      this.reference_number_val = selectedRows.reference_number.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.reference_number.toUpperCase() === this.reference_number_val.toUpperCase() )
    }else if (selectedRows.barcodelabelNumber){
      this.barcode_label_val = selectedRows.barcodelabelNumber.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.barcodelabelNumber.toUpperCase() === this.barcode_label_val.toUpperCase() )
    }else if(selectedRows.articleID){
      this.articleID_val = selectedRows.articleID.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.articleID.toUpperCase() === this.articleID_val.toUpperCase() )
    }else if(selectedRows.dateAllocated){
      this.dateAllocated_val = selectedRows.dateAllocated.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.dateAllocated.toUpperCase() === this.dateAllocated_val.toUpperCase() )
    }else if(selectedRows.broker_Name){
      this.broker_Name_val = selectedRows.broker_Name.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.broker_Name.toUpperCase() === this.broker_Name_val.toUpperCase() )
    }else if(selectedRows.carrier){
      this.carrier_val = selectedRows.carrier.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.carrier.toUpperCase() === this.carrier_val.toUpperCase() )
    }else if(selectedRows.status){
      this.status_val = selectedRows.status.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.status.toUpperCase() === this.status_val.toUpperCase() )
    }else if(selectedRows.receiverName){
      this.receiverName_val = selectedRows.receiverName.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.receiverName.toUpperCase() === this.receiverName_val.toUpperCase() )
    }else if(selectedRows.receiverAddress){
      this.receiverAddress_val = selectedRows.receiverAddress.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.receiverAddress.toUpperCase() === this.receiverAddress_val.toUpperCase() )
    }else if(selectedRows.phoneNumber){
      this.phoneNumber_val = selectedRows.phoneNumber.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.phoneNumber.toUpperCase() === this.phoneNumber_val.toUpperCase() )
    }else if(selectedRows.state){
      this.state_val = selectedRows.state.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.state.toUpperCase() === this.state_val.toUpperCase() )
    }else if(selectedRows.postcode){
      this.postcode_val = selectedRows.postcode.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.postcode.toUpperCase() === this.postcode_val.toUpperCase() )
    }else if(selectedRows.comments){
      this.comments_val = selectedRows.comments.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.comments.toUpperCase() === this.comments_val.toUpperCase() )
    }else if(selectedRows.status_Timestamp){
      this.status_Timestamp_val = selectedRows.status_Timestamp.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.status_Timestamp.toUpperCase() === this.status_Timestamp_val.toUpperCase() )
    }else if(selectedRows.systemStatus){
      this.systemStatus_val = selectedRows.systemStatus.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.systemStatus.toUpperCase() === this.systemStatus_val.toUpperCase() )
    }else if(selectedRows.updated_Timestamp){
      this.updated_Timestamp_val = selectedRows.updated_Timestamp.filter;
      selectedResentFilterRows = selectedRowsResent.filter(x => x.updated_Timestamp.toUpperCase() === this.updated_Timestamp_val.toUpperCase() )
    }else{
      selectedResentFilterRows = selectedRowsResent;
    }

    if(selectedResentFilterRows.length > 0 ){
          this.fileDownload(selectedResentFilterRows, "Customer Service - Resent Data ")
    }else{
          this.errorMsg = "**Please select the below records to download the Resent Data Details";
    }
  };

}

export interface csSystemSelectedVal {
  action,
  reference_number,
  airwayBill,
  articleID,
  barcodelabelNumber,
  broker_Name,
  carrier,
  systemStatus,
  created_Timestamp,
  service_type,
  user_id,
  handling,
  comments,
  user_Id,
  user
}

export interface userMessage {
  userName,
  password,
  brokerUserName
}


// WEBPACK FOOTER //
// ./src/app/cs/views/client-home/client-home.component.ts